import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { BASE_URL } from "../../../config/axios";
// import usePermission from "../../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';
import { handleErrorToast, ProgressModal } from "../../CustomFunctions";
import { AddwithWhiteCircle, DeleteDustbin, UpdatePencil } from "../../AllSvg";
import { AddBOQEmployee } from "../../Wfm/WorkforceCrudButton";
import { Building, Building2Icon, File, Printer, Table, ToolCase, ToolCaseIcon, Tv, X } from "lucide-react";



const AddBreakdownOfCosts = ({ id, getBreakdowncost, logData, breakDownList, breakDownSubProfessional, breakDownSupport }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false); // loading state\
    const [showCreateEmployeeModal, setShowCreateEmployeeModal] = useState(false);




    // Initial form data state
    const [formData, setFormData] = useState({
        rate: "",
        MM_construction_period: "",
        MM_OM_period: "",
        project: id,
        professional_type: null,
        designation: "",
        random_value_of_changes: "",
        reason_of_change: "",
        empcode: [],
        eot_details: [],
        total_amount: 0,
        total_month: 0,

    });


    const [eotObjects, setEotObjects] = useState([]);

    useEffect(() => {
        if (Array.isArray(breakDownList) && breakDownList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = breakDownList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    rate: 0,
                    cp: 0,
                    dlp: 0,
                    rate: 0,
                    t_month: 0,
                    boqId: breakDownList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [breakDownList]);

    console.log(eotObjects);

    console.log(formData)



    useEffect(() => {
        if (breakDownList?.length === 0) return;

        const anyReasonFilled = breakDownList?.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );

        if (anyReasonFilled) {
            const latestRandom = [...breakDownList]
                .filter(item => item.random_value_of_changes && !isNaN(new Date(item.random_value_of_changes)))
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = breakDownList?.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }
    }, [breakDownList]);

    console.log("formData.random_value_of_changes");
    console.log(formData.random_value_of_changes);

    // useEffect(() => {

    //     if (formData.professional_type === "Key Professional") {
    //         if (breakDownList.length === 0) return;

    //         const anyReasonFilled = breakDownList.some(
    //             (item) =>
    //                 item.reason_of_change !== "null" &&
    //                 item.reason_of_change !== null &&
    //                 item.reason_of_change !== ""
    //         );


    //         if (anyReasonFilled) {
    //             const latestRandom = [...breakDownList]
    //                 .filter(item => item.random_value_of_changes)
    //                 .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

    //             if (latestRandom?.random_value_of_changes) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     random_value_of_changes: latestRandom.random_value_of_changes,
    //                     reason_of_change: latestRandom.reason_of_change || "",
    //                 }));
    //             }
    //         } else {
    //             const existingRandom = breakDownList.find(
    //                 (item) =>
    //                     item.random_value_of_changes &&
    //                     (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
    //             );

    //             if (existingRandom) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     random_value_of_changes: existingRandom.random_value_of_changes,
    //                     reason_of_change: existingRandom.reason_of_change || "",
    //                 }));
    //             }
    //         }

    //         console.log("logData")
    //         console.log(logData)
    //         console.log("breakDownList")
    //         console.log(breakDownList)
    //         console.log("breakDownList")
    //         console.log(formData.random_value_of_changes)
    //         console.log(formData.random_value_of_changes)

    //     }
    //     else if (formData.professional_type === "Sub Professional") {
    //         if (breakDownSubProfessional.length === 0) return;

    //         const anyReasonFilled = breakDownSubProfessional.some(
    //             (item) =>
    //                 item.reason_of_change !== "null" &&
    //                 item.reason_of_change !== null &&
    //                 item.reason_of_change !== ""
    //         );


    //         if (anyReasonFilled) {
    //             const latestRandom = [...breakDownSubProfessional]
    //                 .filter(item => item.random_value_of_changes)
    //                 .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

    //             if (latestRandom?.random_value_of_changes) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     random_value_of_changes: latestRandom.random_value_of_changes,
    //                     reason_of_change: latestRandom.reason_of_change || "",
    //                 }));
    //             }
    //         } else {
    //             const existingRandom = breakDownSubProfessional.find(
    //                 (item) =>
    //                     item.random_value_of_changes &&
    //                     (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
    //             );

    //             if (existingRandom) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     random_value_of_changes: existingRandom.random_value_of_changes,
    //                     reason_of_change: existingRandom.reason_of_change || "",
    //                 }));
    //             }
    //         }
    //         console.log("logData")
    //         console.log(logData)
    //         console.log("breakDownSubProfessional")
    //         console.log(breakDownSubProfessional)
    //         console.log("breakDownSubProfessional")
    //         console.log(formData.random_value_of_changes)
    //         console.log(formData.random_value_of_changes)

    //     }
    //     else if (formData.professional_type === "Support Staff") {
    //         if (breakDownSupport.length === 0) return;

    //         const anyReasonFilled = breakDownSupport.some(
    //             (item) =>
    //                 item.reason_of_change !== "null" &&
    //                 item.reason_of_change !== null &&
    //                 item.reason_of_change !== ""
    //         );


    //         if (anyReasonFilled) {
    //             const latestRandom = [...breakDownSupport]
    //                 .filter(item => item.random_value_of_changes)
    //                 .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

    //             if (latestRandom?.random_value_of_changes) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     random_value_of_changes: latestRandom.random_value_of_changes,
    //                     reason_of_change: latestRandom.reason_of_change || "",
    //                 }));
    //             }
    //         } else {
    //             const existingRandom = breakDownSupport.find(
    //                 (item) =>
    //                     item.random_value_of_changes &&
    //                     (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
    //             );

    //             if (existingRandom) {
    //                 setFormData((prev) => ({
    //                     ...prev,
    //                     random_value_of_changes: existingRandom.random_value_of_changes,
    //                     reason_of_change: existingRandom.reason_of_change || "",
    //                 }));
    //             }
    //         }
    //         console.log("logData")
    //         console.log(logData)
    //         console.log("breakDownSubProfessional")
    //         console.log(breakDownSubProfessional)
    //         console.log("breakDownSubProfessional")
    //         console.log(formData.random_value_of_changes)
    //         console.log(formData.random_value_of_changes)

    //     }
    //     else {
    //         setFormData((prev) => ({
    //             ...prev,
    //             random_value_of_changes: "",
    //             reason_of_change: "",
    //         }));
    //     }
    // }, [breakDownList, breakDownSubProfessional, breakDownSupport, formData.professional_type]);





    // Error and input state


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    // Open modal and fetch necessary data
    const handleShow = () => {
        setShow(true);
        getEmployee("null");
    };

    // Close modal
    const handleClose = () => {
        setShow(false);
        setFormData({
            rate: "",
            MM_construction_period: "",
            MM_OM_period: "",
            eot_details: [],

            project: id,
            professional_type: null,
            designation: "",
            random_value_of_changes: "",
            reason_of_change: "",
            empcode: [],
            total_amount: 0,
            total_month: 0,
        })
    }

    // Validate form fields
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["designation"]; // Add other required fields if needed

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let parsedValue = value;

        // Handle numeric fields
        if (name === "rate" || name === "MM_construction_period" || name === "MM_OM_period") {
            parsedValue = value !== "" ? parseInt(value, 10) : "";
            if (isNaN(parsedValue) || parsedValue < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Please enter a valid positive number.",
                }));
                parsedValue = "";
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "",
                }));
            }
        }

        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]: parsedValue,
            };

            // Calculate total month (construction + O&M)
            const totalMonth =
                (parseInt(updated.MM_construction_period) || 0) +
                (parseInt(updated.MM_OM_period) || 0);

            // Calculate total amount (rate * total month)
            const totalAmount =
                (parseInt(updated.rate) || 0) * totalMonth;

            return {
                ...updated,
                total_month: totalMonth || 0,
                total_amount: totalAmount || 0,
            };
        });
    };


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); // Start loading
            const loadingToastId = toast.loading("Loading: Please wait..."); // Display loading toast

            try {
                const res = await axios.post(`${BASE_URL}/siteproject/boqemployee/`, formData);

                if (res.status === 200) {
                    await getBreakdowncost();
                    handleClose();
                    toast.dismiss(loadingToastId); // Dismiss loading toast
                    toast.success('Employee BOQ data added successfully.')
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add Employeee!");
                }
            } catch (err) {
                handleErrorToast(err); // Handle errors
            } finally {
                setLoading(false); // Stop loading
                toast.dismiss(loadingToastId); // Dismiss loading toast
            }
        }
    };


    //! **************************** Get API  ***********************!//
    const [employeeList, setEmployeeList] = useState([]);
    // const [ setBuffering] = useState(true);

    const [designation, setDesignation] = useState([]);


    const getEmployee = async (value) => {
        // setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(
                `${BASE_URL}/siteproject/employeeboqbyproject/${id}/${value}/`
            );
            setEmployeeList(pro.data);
            console.log(pro.data)
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            // setBuffering(false); // End Buffering
        }
    };



    const sub_company = "a2b6154c-5c4a-4bcb-a4ec-b151c5c652b5"

    useEffect(() => {
        if (sub_company) {
            const getDesignation = async () => {
                try {
                    const response = await axios.get(`${BASE_URL}/siteproject/designationfilterbysubcompany/${sub_company}/`);
                    setDesignation(response.data);
                } catch (error) {
                    // Handle error if needed
                    console.error("Error fetching designations:", error);
                }
            };

            // Call the function
            getDesignation();
        }
    }, [sub_company]);
    //! **************************** Get API  End ***********************!//


    console.log(employeeList)
    console.log("Designation")
    console.log(formData.designation)




    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (formData.designation !== "") {
            const filterOptions = employeeList.filter(i => i.designation === formData.designation);
            if (filterOptions.length !== 0) {
                const empList = filterOptions.map((i) => ({
                    value: i.id,
                    label: `${i.emp_code} - ${i.name}`,
                }))

                setOptions(empList)
            }

        }
        else {
            const options = [{
                value: 'create-new-employee',
                label: 'Create New Employee',
            }]

            setOptions(options)

        }

    }, [formData.designation, employeeList])


    console.log("options");
    console.log(options);

    console.log("formdata.designation")
    console.log(formData.designation)



    // const options = useMemo(() => [
    //     {
    //         value: 'create-new-employee',
    //         label: 'Create New Employee',
    //     },
    //     ...(formData.designation
    //         ? employeeList
    //             .filter((employee) => employee.designation === formData.designation)
    //             .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code) || a.emp_code.localeCompare(b.emp_code))
    //             .map((e) => ({
    //                 value: e.id,
    //                 label: `${e.emp_code} - ${e.name}`,
    //             }))
    //         : []),
    // ], [employeeList, formData.designation]);

    const handleChangecc = (selected) => {
        const empcode = Array.isArray(selected) && selected.length > 0
            ? selected.map((item) => item.value)
            : "";

        if (empcode.includes('create-new-employee')) {
            setShowCreateEmployeeModal(true);
        } else {
            setFormData((prevState) => ({
                ...prevState,
                empcode,
            }));
        }
    };




    return (
        <>
            <button title="Designation" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "}Add Employee BOQ
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Designation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div
                                    title="emp_code"
                                    className="flex-column form-group-selectt"
                                >
                                    <label
                                        htmlFor="designation"
                                        className="form-labels  font-weight500    font-size-subheading" title="Designation"
                                    >
                                        Designation<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="designation"
                                        name="designation"
                                        title="Desigantion"
                                        placeholder="designation"
                                        value={formData.designation}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.designation
                                            ? "error"
                                            : inputState.designation
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="" title="Select Designation">Select Designation</option>
                                        {designation
                                            ?.sort((a, b) =>
                                                a.title.localeCompare(b.title, "en", {
                                                    ignorePunctuation: true,
                                                })
                                            )
                                            .map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.title}
                                                    {i.name}
                                                </option>
                                            ))}
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            className="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    {errors.project && (
                                        <span className="error-message font-size-text ">
                                            {errors.project}
                                        </span>
                                    )}
                                </div>

                                <div title="Professional Type" className="flex-column form-group-selectt">
                                    <label htmlFor="professional_type" className="form-labels  font-weight500    font-size-subheading" title="Professional Type">
                                        Professional Type<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="professional_type"
                                        name="professional_type"
                                        title="Professional Type"
                                        value={formData.professional_type}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.professional_type ? "error" : inputState.professional_type ? "success" : ""
                                            }`}
                                    >
                                        <option value="null">Select a Professional </option>
                                        <option value="Key Professional">Key Professional</option>
                                        <option value="Sub Professional">Sub Professional</option>
                                        <option value="Support Staff">Support Staff</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.professional_type && (
                                            <span className="error-message font-size-text ">{errors.professional_type}</span>
                                        )}
                                    </div>
                                </div>


                                <div className="flex-column">
                                    <label
                                        htmlFor="names"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Name
                                    </label>
                                    <Select
                                        options={options}
                                        isMulti
                                        placeholder="Select Name"
                                        onChange={handleChangecc}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '33vw',
                                                minHeight: '50px',
                                                borderRadius: '10px',
                                                border: '1px solid #e3e3e3',
                                                margin: '10px 0px 20px 0px',
                                                color: '#4a4a4a',
                                                backgroundColor: '#f7f8fa',
                                                padding: '0px 10px',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: '33vw',
                                                borderRadius: '10px',
                                                marginTop: '0',
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                        }}
                                    />

                                </div>


                                {showCreateEmployeeModal && <AddBOQEmployee projectId={id} getEmployee={getEmployee} professional_type={formData.professional_type} designation={formData.designation} />}



                                <div className="flex-column">
                                    <label
                                        htmlFor="rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate"
                                    >
                                        Rate (Rs.)
                                    </label>
                                    <input
                                        id="rate"
                                        type="number"
                                        title="Rate"
                                        // min={0}
                                        name="rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate"
                                        onChange={handleInputChange}
                                        value={formData.rate}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="MM_construction_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="MM Construction Period"
                                    >
                                        MM Construction Period
                                    </label>
                                    <input
                                        id="MM_construction_period"
                                        type="number"
                                        title="MM Contruction Period"
                                        name="MM_construction_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="MM Construction Period"
                                        onChange={handleInputChange}
                                        value={formData.MM_construction_period}
                                        className={`form-input ${errors.MM_construction_period
                                            ? "error"
                                            : inputState.MM_construction_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.MM_construction_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.MM_construction_period}
                                        </span>
                                    )}
                                </div>



                                <div className="flex-column">
                                    <label
                                        htmlFor="MM_OM_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="MM OM Period"
                                    >
                                        MM OM Period
                                    </label>
                                    <input
                                        id="MM_OM_period"
                                        type="number"
                                        name="MM_OM_period"
                                        title="M OM Period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="MM OM Period"
                                        onChange={handleInputChange}
                                        value={formData.MM_OM_period}
                                        className={`form-input ${errors.MM_OM_period
                                            ? "error"
                                            : inputState.MM_OM_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.MM_OM_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.MM_OM_period}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="No._of_Man_Months"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of Man Months"
                                    >
                                        No. of Man-Months<span className="required">(Read-Only)</span>
                                    </label>
                                    <input
                                        id="No._of_Man_Months"
                                        type="number"
                                        title="No. of Man Months"
                                        onWheel={(e) => e.target.blur()}
                                        min={0}
                                        placeholder="MM OM Period"
                                        className="form-input"
                                        value={formData.total_month}
                                        readOnly

                                    />
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



const AddSubprofessionalStaff = ({ getSubprofesstion }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        keyPersonnel: "",
        names: "",
        rate: "",
        num_of_man_month: "",
        amount: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["names", "rate", "num_of_man_month", "amount"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqemployee/`,
                    formData
                );

                if (res.status === 200) {
                    await getSubprofesstion();
                    setShow(false);
                    window.location.reload();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Add Item"
                className="models-button model-add"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="#2576BC"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="keyPersonnel"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Position
                                    </label>
                                    <input
                                        id="keyPersonnel"
                                        type="keyPersonnel"
                                        name="keyPersonnel"

                                        placeholder="Professional type"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.keyPersonnel
                                            ? "error"
                                            : inputState.keyPersonnel
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.keyPersonnel && (
                                        <span className="error-message font-size-text ">
                                            {errors.keyPersonnel}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="names"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Name
                                    </label>
                                    <input
                                        id="names"
                                        type="names"
                                        name="names"

                                        placeholder="Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.names ? "error" : inputState.names ? "success" : ""
                                            }`}
                                    />
                                    {errors.names && (
                                        <span className="error-message font-size-text ">
                                            {errors.names}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Staff Months
                                    </label>
                                    <input
                                        id="rate"
                                        type="number"
                                        min={0}
                                        name="rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="num_of_man_month"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Billing Rate(Rs.)
                                    </label>
                                    <input
                                        id="num_of_man_month"
                                        type="number"
                                        min={0}
                                        name="num_of_man_month"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Number of man month"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.num_of_man_month
                                            ? "error"
                                            : inputState.num_of_man_month
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.num_of_man_month && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_man_month}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="amount"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Amount (Rs.)
                                    </label>
                                    <input
                                        id="amount"
                                        type="number"
                                        min={0}
                                        name="amount"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Amount"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.amount
                                            ? "error"
                                            : inputState.amount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.amount && (
                                        <span className="error-message font-size-text ">
                                            {errors.amount}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const AddSupportStaff = ({ getSupportStaff }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        keyPersonnel: "",
        names: "",
        rate: "",
        num_of_man_month: "",
        amount: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["names", "rate", "num_of_man_month", "amount"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqemployee/`,
                    formData
                );

                if (res.status === 200) {
                    await getSupportStaff();
                    setShow(false);
                    window.location.reload();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Add Item"
                className="models-button model-add"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="#2576BC"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="keyPersonnel"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Position
                                    </label>
                                    <input
                                        id="keyPersonnel"
                                        type="keyPersonnel"
                                        name="keyPersonnel"

                                        placeholder="Professional type"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.keyPersonnel
                                            ? "error"
                                            : inputState.keyPersonnel
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.keyPersonnel && (
                                        <span className="error-message font-size-text ">
                                            {errors.keyPersonnel}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="names"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Name
                                    </label>
                                    <input
                                        id="names"
                                        type="names"
                                        name="names"

                                        placeholder="Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.names ? "error" : inputState.names ? "success" : ""
                                            }`}
                                    />
                                    {errors.names && (
                                        <span className="error-message font-size-text ">
                                            {errors.names}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Staff Months
                                    </label>
                                    <input
                                        id="rate"
                                        type="number"
                                        min={0}
                                        name="rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="num_of_man_month"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Billing Rate(Rs.)
                                    </label>
                                    <input
                                        id="num_of_man_month"
                                        type="number"
                                        min={0}
                                        name="num_of_man_month"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Number of man month"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.num_of_man_month
                                            ? "error"
                                            : inputState.num_of_man_month
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.num_of_man_month && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_man_month}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="amount"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Amount (Rs.)
                                    </label>
                                    <input
                                        id="amount"
                                        type="number"
                                        min={0}
                                        name="amount"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Amount"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.amount
                                            ? "error"
                                            : inputState.amount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.amount && (
                                        <span className="error-message font-size-text ">
                                            {errors.amount}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateBreakdownOfCosts = ({ i, id, getBreakdowncost }) => {
    const [show, setShow] = useState(false);

    console.log("i")
    console.log(i)

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        getEmployee(i.professional_type);
        getDesignation();
        setFormData(i)
    };

    const [formData, setFormData] = useState({
        rate: "",
        num_of_man_month: "",
        project: id,
        professional_type: null,
        MM_OM_period: "",
        MM_construction_period: "",
        designation: "",
        empcode: [],
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),



        // sub_company: sessionStorage.getItem('company_id')
    });




    const [inputState, setInputState] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // !  ************** Validation start **************  ! //


    useEffect(() => {
        if (show == true) {
            setFormData((prev) => ({
                ...prev,
                change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
                change_by_emp_name: sessionStorage.getItem('name'),
            }))
        }
    }, [show])


    console.log("formData")
    console.log(formData)

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    console.log(errors)

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqemployeeupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    // await getBreakdowncost();
                    setShow(false);
                    // window.location.reload();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;

    //     // Update input state based on the trimmed value
    //     setInputState({
    //         ...inputState,
    //         [name]: value.trim() ? "green" : "",
    //     });

    //     // Update form data state
    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });

    //     // Conditionally call getEmployee() if name is "professional_type"
    //     if (name === "professional_type") {
    //         getEmployee(value);
    //     }
    // };
    //! **************************** Get API  ***********************!//
    const [employeeList, setEmployeeList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const [designation, setDesignation] = useState([]);


    const getEmployee = async (value) => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(
                `${BASE_URL}/siteproject/employeeboqbyproject/${id}/${value}/`
            );
            setEmployeeList(pro.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const getDesignation = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(
                `${BASE_URL}/siteproject/designation/`
            );
            setDesignation(pro.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };
    //! **************************** Get API  End ***********************!//

    const options = employeeList
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));

    const handleChangecc = (selected) => {
        const empcode = selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({
            ...prevState,
            empcode,

        }));
    };

    return (
        <>
            <button
                title="Update Designation"
                className="models-button model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Employees for : {i.professional_type}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column" title="Name">
                                <label
                                    htmlFor="names"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Name
                                </label>
                                <Select
                                    options={options}
                                    onChange={handleChangecc}
                                    placeholder={i.employee_name_details[0]?.name}
                                    isMulti
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f7f8fa',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />
                                {errors.remarks && (
                                    <span className="error-message font-size-text ">{errors.remarks}</span>
                                )}
                            </div>
                            <div className="flex-column">
                                <label
                                    htmlFor="rate"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate"
                                >
                                    Rate (Rs.)
                                </label>
                                <input
                                    id="rate"
                                    type="number"
                                    title="Rate"
                                    min={0}
                                    name="rate"
                                    onWheel={(e) => e.target.blur()}

                                    placeholder="Rate"
                                    onChange={handleInputChange}
                                    value={formData.rate}
                                    className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                        }`}
                                />
                                {errors.rate && (
                                    <span className="error-message font-size-text ">
                                        {errors.rate}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="MM_construction_period"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="MM Construction Period"
                                >
                                    MM Construction Period
                                </label>
                                <input
                                    id="MM_construction_period"
                                    type="number"
                                    title="MM Contruction Period"
                                    name="MM_construction_period"
                                    onWheel={(e) => e.target.blur()}

                                    placeholder="MM Construction Period"
                                    onChange={handleInputChange}
                                    value={formData.MM_construction_period}
                                    className={`form-input ${errors.MM_construction_period
                                        ? "error"
                                        : inputState.MM_construction_period
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.MM_construction_period && (
                                    <span className="error-message font-size-text ">
                                        {errors.MM_construction_period}
                                    </span>
                                )}
                            </div>



                            <div className="flex-column">
                                <label
                                    htmlFor="MM_OM_period"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="MM OM Period"
                                >
                                    MM OM Period
                                </label>
                                <input
                                    id="MM_OM_period"
                                    type="number"
                                    name="MM_OM_period"
                                    title="M OM Period"
                                    onWheel={(e) => e.target.blur()}

                                    placeholder="MM OM Period"
                                    onChange={handleInputChange}
                                    value={formData.MM_OM_period}
                                    className={`form-input ${errors.MM_OM_period
                                        ? "error"
                                        : inputState.MM_OM_period
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.MM_OM_period && (
                                    <span className="error-message font-size-text ">
                                        {errors.MM_OM_period}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="No._of_Man_Months"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of Man Months"
                                >
                                    No. of Man-Months<span className="required">(Read-Only)</span>
                                </label>
                                <input
                                    id="No._of_Man_Months"
                                    type="number"
                                    title="No. of Man Months"
                                    onWheel={(e) => e.target.blur()}
                                    min={0}
                                    placeholder="MM OM Period"
                                    className="form-input"
                                    value={(Number(formData.MM_OM_period) || 0) + (Number(formData.MM_construction_period) || 0)} // Calculate and display the sum
                                    readOnly // Make the input read-only

                                />
                            </div>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};








const AddOfficeFurniture = ({ id, getOfficeFurniture, officefurnitureList, logData }) => {
    const [show, setShow] = useState(false);
    const [eotObjects, setEotObjects] = useState([]);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleClose = () => {
        setShow(false);
        setFormData({
            num_of_months: "",
            rate_per_month: "",
            project: id,
            eot_details: eotObjects.length > 0 ? eotObjects : [],

            random_value_of_changes: "",
            reason_of_change: "",
            during_construction_period: "",
            during_dlp_OM_period: "",
        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        num_of_months: "",
        rate_per_month: "",
        project: id,
        eot_details: eotObjects.length > 0 ? eotObjects : [],

        random_value_of_changes: "",
        reason_of_change: "",
        during_construction_period: "",
        during_dlp_OM_period: "",


        // sub_company: sessionStorage.getItem('company_id')
    });



    useEffect(() => {
        if (Array.isArray(officefurnitureList) && officefurnitureList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = officefurnitureList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    cp: 0,
                    dlp: 0,
                    rate: 0,
                    t_month: 0,
                    boqId: officefurnitureList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [officefurnitureList]);




    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            num_of_months: Number(formData.during_construction_period) + Number(formData.during_dlp_OM_period),
        }))
    }, [formData.during_construction_period, formData.during_dlp_OM_period])


    useEffect(() => {
        if (officefurnitureList.length === 0) return;

        const anyReasonFilled = officefurnitureList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );

        if (anyReasonFilled) {
            const latestRandom = [...officefurnitureList]
                .filter(item => item.random_value_of_changes && !isNaN(new Date(item.random_value_of_changes)))
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = officefurnitureList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }
    }, [officefurnitureList]);



    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["num_of_months", "rate_per_month", "during_dlp_OM_period", "during_construction_period"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqofficefurnitureandequipment/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getOfficeFurniture();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Office Furniture" className="upload-svg flex-row" onClick={handleShow}>
    //             <AddwithWhiteCircle />
    //             {" "} Office Furniture
    //         </button>

    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Office Furniture</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">
    //                         {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="during_construction_period"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     During Construction Period<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="during_construction_period"
    //                                     type="number"
    //                                     name="during_construction_period"
    //                                     title="During Construction Period"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Construction Period Duration"
    //                                     onChange={handleInputChange}
    //                                     value={formData.during_construction_period}
    //                                     className={`form-input ${errors.during_construction_period ? "error" : inputState.during_construction_period ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.during_construction_period && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.during_construction_period}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="during_dlp_OM_period"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     During O&M Period<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="during_dlp_OM_period"
    //                                     type="number"
    //                                     name="during_dlp_OM_period"
    //                                     title="During O&M Period"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="During O&M Period"
    //                                     onChange={handleInputChange}
    //                                     value={formData.during_dlp_OM_period}
    //                                     className={`form-input ${errors.during_dlp_OM_period ? "error" : inputState.during_dlp_OM_period ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.during_dlp_OM_period && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.during_dlp_OM_period}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="num_of_months"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of Months"
    //                                 >
    //                                     No. of Months<span className="required">(Read-Only)</span>
    //                                 </label>
    //                                 <input
    //                                     id="num_of_months"
    //                                     type="number"
    //                                     title="No. of Months"
    //                                     min={0}
    //                                     name="num_of_months"
    //                                     onWheel={(e) => e.target.blur()}
    //                                     readOnly

    //                                     placeholder="No. of Months"
    //                                     onChange={handleInputChange}
    //                                     value={formData.num_of_months}
    //                                     className={`form-input ${errors.num_of_months
    //                                         ? "error"
    //                                         : inputState.num_of_months
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.num_of_months && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.num_of_months}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="rate_per_month"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate per Month"
    //                                 >
    //                                     Rate per Month
    //                                 </label>
    //                                 <input
    //                                     id="rate_per_month"
    //                                     type="numnber"
    //                                     name="rate_per_month"
    //                                     title="Rate Per Month"
    //                                     placeholder="Rate Per Month"
    //                                     onChange={handleInputChange}
    //                                     value={formData.name}
    //                                     className={`form-input ${errors.rate_per_month ? "error" : inputState.rate_per_month ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.rate_per_month && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.rate_per_month}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );


    return (
        <>
            <button
                title="Office Furniture"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <Tv />
                Office Furniture
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <Tv />
                            Add Office Furniture
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* During Construction Period */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="during_construction_period" className="eb-bulk-th-label" title="During Construction Period">
                                                During Construction Period <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="during_construction_period"
                                                type="number"
                                                name="during_construction_period"
                                                title="During Construction Period"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.during_construction_period}
                                                style={{ width: "94%" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.during_construction_period ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.during_construction_period && (
                                                <span className="eb-bulk-error-text">{errors.during_construction_period}</span>
                                            )}
                                        </div>

                                        {/* During O&M Period */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="during_dlp_OM_period" className="eb-bulk-th-label" title="During O&M Period">
                                                During O&M Period <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="during_dlp_OM_period"
                                                type="number"
                                                name="during_dlp_OM_period"
                                                title="During O&M Period"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.during_dlp_OM_period}
                                                style={{ width: "94%" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.during_dlp_OM_period ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.during_dlp_OM_period && (
                                                <span className="eb-bulk-error-text">{errors.during_dlp_OM_period}</span>
                                            )}
                                        </div>

                                        {/* No. of Months (Read-Only) */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="num_of_months" className="eb-bulk-th-label" title="No. of Months">
                                                No. of Months <span className="eb-bulk-required">(Read-Only)</span>
                                            </label>
                                            <input
                                                id="num_of_months"
                                                type="number"
                                                name="num_of_months"
                                                title="No. of Months"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                readOnly
                                                value={formData.num_of_months}
                                                style={{ width: "94%", background: "var(--eb-bulk-input-readonly-bg, #f5f5f5)", cursor: "not-allowed" }}
                                                className="eb-bulk-input eb-bulk-input-number"
                                            />
                                        </div>

                                        {/* Rate per Month */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="rate_per_month" className="eb-bulk-th-label" title="Rate per Month">
                                                Rate per Month (Rs.) <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="rate_per_month"
                                                type="number"
                                                name="rate_per_month"
                                                title="Rate per Month"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.rate_per_month}
                                                style={{ width: "94%" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.rate_per_month ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.rate_per_month && (
                                                <span className="eb-bulk-error-text">{errors.rate_per_month}</span>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const AddReportsPrinting = ({ id, getReportsPrinting, reportPageList }) => {
    const [show, setShow] = useState(false);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [eotObjects, setEotObjects] = useState([]);
    const handleClose = () => {
        setShow(false);
        setFormData({
            description: "",
            num_of_reports: "",
            num_of_copies_per_report: "",
            rate_per_copy: "",
            project: id,
            random_value_of_changes: "",
            revised: eotObjects.length > 0 ? eotObjects : [],
            reason_of_change: "",
        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        description: "",
        num_of_reports: "",
        num_of_copies_per_report: "",
        rate_per_copy: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: "",
        revised: eotObjects.length > 0 ? eotObjects : [],

        // sub_company: sessionStorage.getItem('company_id')
    });



    useEffect(() => {
        if (Array.isArray(reportPageList) && reportPageList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = reportPageList[0]?.revised?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    rate_per_copy: 0,
                    num_of_copies_per_report: 0,
                    num_of_reports: 0,
                    t_reports: 0,
                    boqId: reportPageList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    revised: newEots
                }))
            }
        }
    }, [reportPageList]);


    console.log("eotObjects");
    console.log(eotObjects);

    useEffect(() => {


        if (reportPageList.length === 0) return;

        const anyReasonFilled = reportPageList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );


        if (anyReasonFilled) {
            const latestRandom = [...reportPageList]
                .filter(item => item.random_value_of_changes)
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = reportPageList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }

    }, [reportPageList]);


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "num_of_reports", "num_of_copies_per_report", "rate_per_copy"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqreportsanddocprint/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getReportsPrinting();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Report & Document" className="upload-svg flex-row" onClick={handleShow}>
    //             <svg
    //                 xmlns="http://www.w3.org/2000/svg"
    //                 width="24"
    //                 height="24"
    //                 viewBox="0 0 24 24"
    //                 fill="none"
    //             >
    //                 <g clip-path="url(#clip0_1415_3177)">
    //                     <path
    //                         d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
    //                         fill="white"
    //                     />
    //                 </g>
    //                 <defs>
    //                     <clipPath id="clip0_1415_3177">
    //                         <rect width="24" height="24" fill="white" />
    //                     </clipPath>
    //                 </defs>
    //             </svg>
    //             {" "} Report & Doc
    //         </button>

    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Report & Document</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">
    //                         {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="description"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Description"
    //                                 >
    //                                     Description<span className="required">*</span>
    //                                 </label>
    //                                 <textarea
    //                                     id="description"
    //                                     type="text"
    //                                     name="description"
    //                                     title="Description"
    //                                     maxLength={300}
    //                                     placeholder="Description"
    //                                     onChange={handleInputChange}
    //                                     value={formData.description}
    //                                     className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
    //                                         ? "error"
    //                                         : inputState.description
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.description && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.description}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="num_of_reports"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of Reports"
    //                                 >
    //                                     No. of Reports<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="num_of_reports"
    //                                     type="number"
    //                                     title="No. of Reports"
    //                                     name="num_of_reports"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="No. of Reports"
    //                                     onChange={handleInputChange}
    //                                     value={formData.num_of_reports}
    //                                     className={`form-input ${errors.num_of_reports ? "error" : inputState.num_of_reports ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.num_of_reports && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.num_of_reports}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="num_of_copies_per_report"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of Copies per Report"
    //                                 >
    //                                     No. of Copies per Report<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="num_of_copies_per_report"
    //                                     type="number"
    //                                     title="No. of copies per Report"
    //                                     min={0}
    //                                     name="num_of_copies_per_report"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="No. of Copies per Report"
    //                                     onChange={handleInputChange}
    //                                     value={formData.num_of_copies_per_report}
    //                                     className={`form-input ${errors.num_of_copies_per_report ? "error" : inputState.num_of_copies_per_report ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.num_of_copies_per_report && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.num_of_copies_per_report}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="rate_per_copy"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate per Copy"
    //                                 >
    //                                     Rate per Copy<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="rate_per_copy"
    //                                     type="number"
    //                                     title="Rate Per Copy"
    //                                     min={0}
    //                                     onWheel={(e) => e.target.blur()}
    //                                     name="rate_per_copy"

    //                                     placeholder="Rate per Copy"
    //                                     onChange={handleInputChange}
    //                                     value={formData.rate_per_copy}
    //                                     className={`form-input ${errors.rate_per_copy
    //                                         ? "error"
    //                                         : inputState.rate_per_copy
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.rate_per_copy && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.rate_per_copy}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );

    return (
        <>
            <button
                title="Report & Document"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <File />
                Add Report & Doc
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <File />
                            Add Report & Document
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* Description */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="description" className="eb-bulk-th-label" title="Description">
                                                Description <span className="eb-bulk-required">*</span>
                                            </label>
                                            <textarea
                                                id="description"
                                                name="description"
                                                title="Description"
                                                maxLength={300}
                                                placeholder="Description"
                                                onChange={handleInputChange}
                                                value={formData.description}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input ${errors.description ? "eb-bulk-input-error" : ""}`}
                                                rows={3}
                                            />
                                            {errors.description && (
                                                <span className="eb-bulk-error-text">{errors.description}</span>
                                            )}
                                        </div>

                                        {/* No. of Reports */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="num_of_reports" className="eb-bulk-th-label" title="No. of Reports">
                                                No. of Reports <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="num_of_reports"
                                                type="number"
                                                name="num_of_reports"
                                                title="No. of Reports"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.num_of_reports}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.num_of_reports ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.num_of_reports && (
                                                <span className="eb-bulk-error-text">{errors.num_of_reports}</span>
                                            )}
                                        </div>

                                        {/* No. of Copies per Report */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="num_of_copies_per_report" className="eb-bulk-th-label" title="No. of Copies per Report">
                                                No. of Copies per Report <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="num_of_copies_per_report"
                                                type="number"
                                                name="num_of_copies_per_report"
                                                title="No. of Copies per Report"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.num_of_copies_per_report}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.num_of_copies_per_report ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.num_of_copies_per_report && (
                                                <span className="eb-bulk-error-text">{errors.num_of_copies_per_report}</span>
                                            )}
                                        </div>

                                        {/* Rate per Copy */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="rate_per_copy" className="eb-bulk-th-label" title="Rate per Copy">
                                                Rate per Copy (Rs.) <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="rate_per_copy"
                                                type="number"
                                                name="rate_per_copy"
                                                title="Rate per Copy"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.rate_per_copy}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.rate_per_copy ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.rate_per_copy && (
                                                <span className="eb-bulk-error-text">{errors.rate_per_copy}</span>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const AddRoadSurveyEquipment = ({ id, getRoadSurveyEquipment, roadSureveyList }) => {
    const [show, setShow] = useState(false);
    const [eotObjects, setEotObjects] = useState([]);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleClose = () => {
        setShow(false);
        setFormData({
            KM: "",
            description: "",
            num_of_times_survey_concluded: "",
            rate_per_km_times: "",
            project: id,
            random_value_of_changes: "",
            reason_of_change: "",
            eot_details: eotObjects.length > 0 ? eotObjects : [],

        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        KM: "",
        description: "",
        num_of_times_survey_concluded: "",
        rate_per_km_times: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: "",
        eot_details: eotObjects.length > 0 ? eotObjects : [],

        // sub_company: sessionStorage.getItem('company_id')
    });


    useEffect(() => {
        if (Array.isArray(roadSureveyList) && roadSureveyList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = roadSureveyList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    KM: 0,
                    rate_per_km_times: 0,
                    num_of_times_survey_concluded: 0,

                    boqId: roadSureveyList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [roadSureveyList]);


    useEffect(() => {


        if (roadSureveyList.length === 0) return;

        const anyReasonFilled = roadSureveyList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );


        if (anyReasonFilled) {
            const latestRandom = [...roadSureveyList]
                .filter(item => item.random_value_of_changes)
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = roadSureveyList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }

    }, [roadSureveyList]);


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "num_of_times_survey_concluded", "rate_per_km_times", "KM"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqroadsurveyequipment/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getRoadSurveyEquipment();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Road Survey" className="upload-svg flex-row" onClick={handleShow}>
    //             <svg
    //                 xmlns="http://www.w3.org/2000/svg"
    //                 width="24"
    //                 height="24"
    //                 viewBox="0 0 24 24"
    //                 fill="none"
    //             >
    //                 <g clip-path="url(#clip0_1415_3177)">
    //                     <path
    //                         d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
    //                         fill="white"
    //                     />
    //                 </g>
    //                 <defs>
    //                     <clipPath id="clip0_1415_3177">
    //                         <rect width="24" height="24" fill="white" />
    //                     </clipPath>
    //                 </defs>
    //             </svg>
    //             {" "} Road Survey
    //         </button>

    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Road Survey</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">
    //                         {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="description"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Description"
    //                                 >
    //                                     Description<span className="required">*</span>
    //                                 </label>
    //                                 <textarea
    //                                     id="description"
    //                                     type="text"
    //                                     title="Description"
    //                                     name="description"
    //                                     maxLength={300}
    //                                     placeholder="Description"
    //                                     onChange={handleInputChange}
    //                                     value={formData.description}
    //                                     className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
    //                                         ? "error"
    //                                         : inputState.description
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.description && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.description}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="KM"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="KM"
    //                                 >
    //                                     KM<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="KM"
    //                                     type="number"
    //                                     titel="KM"
    //                                     min={0}
    //                                     name="KM"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="KM"
    //                                     onChange={handleInputChange}
    //                                     value={formData.KM}
    //                                     className={`form-input ${errors.KM ? "error" : inputState.KM ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.KM && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.KM}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="num_of_times_survey_concluded"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of times Survey Concluded"
    //                                 >
    //                                     No. of times Survey Concluded<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="num_of_times_survey_concluded"
    //                                     type="number"
    //                                     title="No. of times Survey Concluded"
    //                                     min={0}
    //                                     name="num_of_times_survey_concluded"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="No. of times Survey Concluded"
    //                                     onChange={handleInputChange}
    //                                     value={formData.num_of_times_survey_concluded}
    //                                     className={`form-input ${errors.num_of_times_survey_concluded ? "error" : inputState.num_of_times_survey_concluded ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.num_of_times_survey_concluded && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.num_of_times_survey_concluded}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="rate_per_km_times"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate per No. of times Survey to be Conducted"
    //                                 >
    //                                     Rate per No. of times Survey to be Conducted<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="rate_per_km_times"
    //                                     type="number"
    //                                     title="Rate per No. of times Survey to be Conducted"
    //                                     min={0}
    //                                     name="rate_per_km_times"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Rate per No. of times Survey to be Conducted"
    //                                     onChange={handleInputChange}
    //                                     value={formData.rate_per_km_times}
    //                                     className={`form-input ${errors.rate_per_km_times ? "error" : inputState.rate_per_km_times ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.rate_per_km_times && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.rate_per_km_times}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );

    return (
        <>
            <button
                title="Road Survey"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <ToolCaseIcon />
                Add Road Survey
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <ToolCaseIcon />

                            Add Road Survey
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* Description */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="description" className="eb-bulk-th-label" title="Description">
                                                Description <span className="eb-bulk-required">*</span>
                                            </label>
                                            <textarea
                                                id="description"
                                                name="description"
                                                title="Description"
                                                maxLength={300}
                                                placeholder="Description"
                                                onChange={handleInputChange}
                                                value={formData.description}
                                                rows={3}
                                                style={{ width: "94%", textAlign: "left" }}
                                                className={`eb-bulk-input ${errors.description ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.description && (
                                                <span className="eb-bulk-error-text">{errors.description}</span>
                                            )}
                                        </div>

                                        {/* KM */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="KM" className="eb-bulk-th-label" title="KM">
                                                KM <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="KM"
                                                type="number"
                                                name="KM"
                                                title="KM"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.KM}
                                                style={{ width: "94%", textAlign: "left" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.KM ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.KM && (
                                                <span className="eb-bulk-error-text">{errors.KM}</span>
                                            )}
                                        </div>

                                        {/* No. of times Survey Concluded */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="num_of_times_survey_concluded" className="eb-bulk-th-label" title="No. of times Survey Concluded">
                                                No. of times Survey Concluded <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="num_of_times_survey_concluded"
                                                type="number"
                                                name="num_of_times_survey_concluded"
                                                title="No. of times Survey Concluded"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.num_of_times_survey_concluded}
                                                style={{ width: "94%", textAlign: "left" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.num_of_times_survey_concluded ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.num_of_times_survey_concluded && (
                                                <span className="eb-bulk-error-text">{errors.num_of_times_survey_concluded}</span>
                                            )}
                                        </div>

                                        {/* Rate per No. of times Survey to be Conducted */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="rate_per_km_times" className="eb-bulk-th-label" title="Rate per No. of times Survey to be Conducted">
                                                Rate per No. of times Survey to be Conducted <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="rate_per_km_times"
                                                type="number"
                                                name="rate_per_km_times"
                                                title="Rate per No. of times Survey to be Conducted"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.rate_per_km_times}
                                                style={{ width: "94%", textAlign: "left" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.rate_per_km_times ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.rate_per_km_times && (
                                                <span className="eb-bulk-error-text">{errors.rate_per_km_times}</span>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const AddContingencies = ({ id, getContingencies, contilist }) => {
    const [show, setShow] = useState(false);
    const [eotObjects, setEotObjects] = useState([]);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const handleClose = () => {
        setShow(false);
        setFormData({
            description: "",
            unit: "",
            ammount: "",
            project: id,
            eot_details: eotObjects.length > 0 ? eotObjects : [],


        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        description: "",
        unit: "",
        ammount: "",
        project: id,
        eot_details: eotObjects.length > 0 ? eotObjects : [],



        // sub_company: sessionStorage.getItem('company_id')
    });



    useEffect(() => {
        if (Array.isArray(contilist) && contilist.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = contilist[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    unit: 0,
                    ammount: 0,

                    boqId: contilist[0].id, // or keep it dynamic
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [contilist]);

    useEffect(() => {
        if (contilist.length === 0) return;

        const anyReasonFilled = contilist.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );

        if (anyReasonFilled) {
            const latestRandom = [...contilist]
                .filter(item => item.random_value_of_changes && !isNaN(new Date(item.random_value_of_changes)))
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = contilist.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }
    }, [contilist]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "unit", "ammount"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqcontingencies/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getContingencies();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Contingencies" className="upload-svg flex-row" onClick={handleShow}>
    //             <svg
    //                 xmlns="http://www.w3.org/2000/svg"
    //                 width="24"
    //                 height="24"
    //                 viewBox="0 0 24 24"
    //                 fill="none"
    //             >
    //                 <g clip-path="url(#clip0_1415_3177)">
    //                     <path
    //                         d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
    //                         fill="white"
    //                     />
    //                 </g>
    //                 <defs>
    //                     <clipPath id="clip0_1415_3177">
    //                         <rect width="24" height="24" fill="white" />
    //                     </clipPath>
    //                 </defs>
    //             </svg>
    //             {" "} Contingencies
    //         </button>

    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Contingencies</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">
    //                         {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="description"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
    //                                 >
    //                                     Description<span className="required">*</span>
    //                                 </label>
    //                                 <textarea
    //                                     id="description"
    //                                     type="text"
    //                                     name="description"
    //                                     maxLength={300}
    //                                     placeholder="Description"
    //                                     onChange={handleInputChange}
    //                                     value={formData.description}
    //                                     className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
    //                                         ? "error"
    //                                         : inputState.description
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.description && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.description}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="unit"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
    //                                 >
    //                                     Units<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="unit"
    //                                     type="text"
    //                                     name="unit"

    //                                     placeholder="Units"
    //                                     onChange={handleInputChange}
    //                                     value={formData.unit}
    //                                     className={`form-input ${errors.unit ? "error" : inputState.unit ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.unit && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.unit}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="ammount"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
    //                                 >
    //                                     Amount<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="ammount"
    //                                     type="number"
    //                                     min={0}
    //                                     name="ammount"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Amount"
    //                                     onChange={handleInputChange}
    //                                     value={formData.ammount}
    //                                     className={`form-input ${errors.ammount ? "error" : inputState.ammount ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.ammount && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.ammount}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );

    return (
        <>
            <button
                title="Contingencies"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clipPath="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                Contingencies
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <g clipPath="url(#clip0_1415_3177)">
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                                        fill="currentColor"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1415_3177">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            Add Contingencies
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* Description */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="description" className="eb-bulk-th-label" title="Description">
                                                Description <span className="eb-bulk-required">*</span>
                                            </label>
                                            <textarea
                                                id="description"
                                                name="description"
                                                title="Description"
                                                maxLength={300}
                                                placeholder="Description"
                                                onChange={handleInputChange}
                                                value={formData.description}
                                                rows={3}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input ${errors.description ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.description && (
                                                <span className="eb-bulk-error-text">{errors.description}</span>
                                            )}
                                        </div>

                                        {/* Units */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="unit" className="eb-bulk-th-label" title="Units">
                                                Units <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="unit"
                                                type="text"
                                                name="unit"
                                                title="Units"
                                                placeholder="Units"
                                                onChange={handleInputChange}
                                                value={formData.unit}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input ${errors.unit ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.unit && (
                                                <span className="eb-bulk-error-text">{errors.unit}</span>
                                            )}
                                        </div>

                                        {/* Amount */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="ammount" className="eb-bulk-th-label" title="Amount">
                                                Amount <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="ammount"
                                                type="number"
                                                name="ammount"
                                                title="Amount"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.ammount}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.ammount ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.ammount && (
                                                <span className="eb-bulk-error-text">{errors.ammount}</span>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const AddOfficeFurnitureHeading = ({ id, getOfficeFurnitureheading }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        BOQoffice_furnitur_equipment: "",
        project: id,

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["BOQoffice_furnitur_equipment"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqheadingtable/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeFurnitureheading();
                    setShow(false);
                    window.location.reload();
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button title="Add Office Furniture Heading Description" className="upload-svg flex-row" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                {" "} Description
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Office Furniture Heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="boqheadingtable"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Heading Description
                                    </label>
                                    <textarea
                                        id="BOQoffice_furnitur_equipment"
                                        name="BOQoffice_furnitur_equipment"
                                        type="text"

                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.BOQoffice_furnitur_equipment}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.boqheadingtable
                                            ? "error"
                                            : inputState.boqheadingtable
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.BOQoffice_furnitur_equipment && (
                                        <span className="error-message font-size-text ">
                                            {errors.BOQoffice_furnitur_equipment}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ! ********************************* Update & Delete Button ****************************


const DeleteBreakdownOfCosts = ({ i, getBreakdownCost, usedFor, getLogData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqemployeeupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getBreakdownCost();
                await getLogData();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Employee BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title={usedFor === "KP" ? "Key Professional" : usedFor === "SP" ? "Sub Professional" : "Support Staff"} className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete {usedFor === "KP" ? "Key Professional" : usedFor === "SP" ? "Sub Professional" : "Support Staff"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.designation_name}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ************************************************************************
// const UpdateSubprofessionalStaff = ({ i, getBreakdownCost }) => {
//     const [show, setShow] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         setShow(true);
//         setFormData(i);
//     };

//     const [formData, setFormData] = useState({
//         vehicle_description: "",
//         during_construction_period: "",
//         during_dlp_OM_period: "",
//         rate: "",
//         project: projectId2,

//         // sub_company: sessionStorage.getItem('company_id')
//     });

//     // !  ************** Validation start **************  ! //

//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});

//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = [
//             "vehicle_description",
//             "during_construction_period",
//             "during_dlp_OM_period",
//             "rate",
//         ];
//         requiredFields.forEach((field) => {
//             if (!formData[field]) {
//                 newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
//                     } is required !`;
//             }
//         });

//         setErrors(newErrors);

//         return Object.keys(newErrors).length === 0;
//     };

//     // ?  ************** Validation End **************  ! //

//     //! **************************** post API ***********************!//
//     const [loading, setLoading] = useState(false); //loading logic

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/boqtransportupdate/${i.id}/`,
//                     formData
//                 );

//                 if (res.status === 200) {
//                     await getBreakdownCost();
//                     setShow(false);
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 if (err.response) {
//                     toast.dismiss(loadingToastId);
//                     const errorData = err.response.data;

//                     if (typeof errorData.error === "string") {
//                         // Single error message
//                         toast.error(`Error: ${errorData.error}`);
//                     } else if (typeof errorData === "object" && errorData !== null) {
//                         // Multiple error messages
//                         Object.entries(errorData).forEach(([field, messages]) => {
//                             messages.forEach((message) =>
//                                 toast.error(`"${field}": ${message}`)
//                             );
//                         });
//                     } else {
//                         toast.error("Error:- Failed to Process!");
//                     }
//                 } else {
//                     toast.error("Error processing your request.");
//                 }
//             } finally {
//                 setLoading(false); //loading logic
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };

//     //! **************************** post API End ***********************!//

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         setInputState({
//             ...inputState,
//             [name]: value.trim() ? "green" : "",
//         });

//         setFormData({
//             ...formData,
//             [name]: value,
//         });
//     };

//     return (
//         <>
//             <button
//                 title="Update Item"
//                 className="model-edit-button"
//                 onClick={handleShow}
//             >
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="18"
//                     height="18"
//                     viewBox="0 0 18 18"
//                     fill="none"
//                 >
//                     <path
//                         d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
//                         fill="#145650"
//                     />
//                 </svg>
//             </button>

//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="request-leave width-40vw"
//             >
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

//                             <form>
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="vehicle_description"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         Description of Vehicles
//                                     </label>
//                                     <input
//                                         id="vehicle_description"
//                                         type="vehicle_description"
//                                         name="vehicle_description"
//                                         
//                                         placeholder="Vehicle description"
//                                         onChange={handleInputChange}
//                                         value={formData.vehicle_description}
//                                         className={`form-input ${errors.vehicle_description
//                                             ? "error"
//                                             : inputState.vehicle_description
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                     />
//                                     {errors.vehicle_description && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.vehicle_description}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="during_construction_period"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         Duration Construction Period{" "}
//                                         <span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="during_construction_period"
//                                         type="number"
//                                         name="during_construction_period"
//                                         
//                                         placeholder="Construction Period"
//                                         onChange={handleInputChange}
//                                         value={formData.during_construction_period}
//                                         className={`form-input ${errors.during_construction_period
//                                             ? "error"
//                                             : inputState.during_construction_period
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                     />
//                                     {errors.during_construction_period && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.during_construction_period}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="during_dlp_OM_period"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         During DLP <span className="required">*</span>{" "}
//                                     </label>
//                                     <input
//                                         id="during_dlp_OM_period"
//                                         type="number"
//                                         min={0}
//                                         name="during_dlp_OM_period"
//                                         
//                                         placeholder="Number of months"
//                                         onChange={handleInputChange}
//                                         value={formData.during_dlp_OM_period}
//                                         className={`form-input ${errors.during_dlp_OM_period
//                                             ? "error"
//                                             : inputState.during_dlp_OM_period
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                     />
//                                     {errors.during_dlp_OM_period && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.during_dlp_OM_period}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="rate"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         Rates
//                                     </label>
//                                     <input
//                                         id="rate"
//                                         type="number"
//                                         min={0}
//                                         name="rate"
//                                         
//                                         placeholder="Rate"
//                                         onChange={handleInputChange}
//                                         value={formData.rate}
//                                         className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.rate && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.rate}
//                                         </span>
//                                     )}
//                                 </div>
//                                 {/* 
//                                 <div className="flex-column">
//                                     <label htmlFor="amount" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                                         Amount (Rs.)
//                                     </label>
//                                     <input
//                                         id="amount"
//                                         type="number"
//                                         min={0}
//                                         name="amount"
//                                         
//                                         placeholder="Amount"
//                                         onChange={handleInputChange}
//                                         value={formData.name}
//                                         className={`form-input ${errors.amount ? "error" : inputState.amount ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.amount && (
//                                         <span className="error-message font-size-text ">{errors.amount}</span>
//                                     )}
//                                 </div> */}
//                             </form>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button   font-weight500   "
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
//                                     onClick={handleSubmit}
//                                     disabled={loading}
//                                 >
//                                     Update
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const DeleteSubprofessionalStaff = ({ i, getBreakdownCost }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqemployeeupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getBreakdownCost();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Sub Professional Staff" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Sub Professional Staff</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500 font-size-heading">Are You Sure You Want to Delete "{i.designation_name}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteSupportStaff = ({ i, getBreakdownCost }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqemployeeupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getBreakdownCost();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Support Staff" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />

            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Support Staff</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.designation_name}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ************************************************************************

const AddTransportation = ({ id, getTransportation, logData, transportationList }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setFormData({
            vehicle_description: "",
            during_construction_period: "",
            during_dlp_OM_period: "",
            eot_details: [],

            rate: "",
            project: id,
            random_value_of_changes: "",
            reason_of_change: "",
        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        vehicle_description: "",
        during_construction_period: "",
        during_dlp_OM_period: "",
        eot_details: [],

        rate: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    const [eotObjects, setEotObjects] = useState([]);


    useEffect(() => {
        if (Array.isArray(transportationList) && transportationList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = transportationList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    cp: 0,
                    dlp: 0,
                    rate: 0,
                    t_month: 0,
                    boqId: transportationList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [transportationList]);


    console.log("eotObjects");
    console.log(eotObjects);


    useEffect(() => {


        if (transportationList.length === 0) return;

        const anyReasonFilled = transportationList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );


        if (anyReasonFilled) {
            const latestRandom = [...transportationList]
                .filter(item => item.random_value_of_changes)
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = transportationList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }

    }, [transportationList]);


    console.log("formData.random_value_of_changes");

    console.log(formData.random_value_of_changes);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "vehicle_description",
            "during_construction_period",
            "during_dlp_OM_period",
            "rate",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqtransport/`,
                    formData
                );

                if (res.status === 200) {
                    await getTransportation();
                    handleClose();
                    toast.dismiss(loadingToastId); // Dismiss loading toast
                    toast.success('Transportation BOQ data added successfully.')
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button title="Transportation" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "} Transportation
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Transportaion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="vehicle_description"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Description of Vehicles"
                                    >
                                        Description of Vehicles<span className="required">*</span>
                                    </label>
                                    <input
                                        id="vehicle_description"
                                        type="text"
                                        title="Description of Vehicle"
                                        name="vehicle_description"
                                        maxLength={300}
                                        placeholder="Vehicle Description"
                                        onChange={handleInputChange}
                                        value={formData.vehicle_description}
                                        className={`form-input   font-weight400  font-size-subheading ${errors.vehicle_description
                                            ? "error"
                                            : inputState.vehicle_description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.vehicle_description && (
                                        <span className="error-message font-size-text ">
                                            {errors.vehicle_description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="during_construction_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Duration Construction Period"
                                    >
                                        Duration Construction Period{" "}
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        id="during_construction_period"
                                        type="number"
                                        title="Duration Construction Period"
                                        name="during_construction_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Construction Period"
                                        onChange={handleInputChange}
                                        value={formData.during_construction_period}
                                        className={`form-input ${errors.during_construction_period
                                            ? "error"
                                            : inputState.during_construction_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.during_construction_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.during_construction_period}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="during_dlp_OM_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="During DLP"
                                    >
                                        During DLP <span className="required">*</span>{" "}
                                    </label>
                                    <input
                                        id="during_dlp_OM_period"
                                        type="number"
                                        title="During DLP"
                                        min={0}
                                        name="during_dlp_OM_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Number of Months"
                                        onChange={handleInputChange}
                                        value={formData.during_dlp_OM_period}
                                        className={`form-input ${errors.during_dlp_OM_period
                                            ? "error"
                                            : inputState.during_dlp_OM_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.during_dlp_OM_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.during_dlp_OM_period}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rates"
                                    >
                                        Rates<span className="required">*</span>
                                    </label>
                                    <input
                                        id="rate"
                                        type="number"
                                        title="Rates"
                                        min={0}
                                        name="rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate"
                                        onChange={handleInputChange}
                                        value={formData.rate}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



const UpdateTransportation = ({ i, getTransportation }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        vehicle_description: "",
        during_construction_period: "",
        during_dlp_OM_period: "",
        rate: "",
        project: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "vehicle_description",
            "during_construction_period",
            "during_dlp_OM_period",
            "rate",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqtransportupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getTransportation();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Vehicle"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >

                <Modal.Header closeButton>
                    <Modal.Title>Update Vehicle {i.vehicle_description}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">


                            <form>
                                <div className="flex-column" title="Vehicle Description">
                                    <label
                                        htmlFor="vehicle_description"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description of Vehicles<span className="required">*</span>
                                    </label>
                                    <input
                                        id="vehicle_description"
                                        type="Description"
                                        name="vehicle_description"
                                        maxLength={300}
                                        placeholder="Vehicle description"
                                        onChange={handleInputChange}
                                        value={formData.vehicle_description}
                                        className={`form-input   font-weight400  font-size-subheading ${errors.vehicle_description
                                            ? "error"
                                            : inputState.vehicle_description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.vehicle_description && (
                                        <span className="error-message font-size-text ">
                                            {errors.vehicle_description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Duration Construction Period">
                                    <label
                                        htmlFor="during_construction_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Duration Construction Period
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        id="during_construction_period"
                                        type="number"
                                        name="during_construction_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Construction Period"
                                        onChange={handleInputChange}
                                        value={formData.during_construction_period}
                                        className={`form-input ${errors.during_construction_period
                                            ? "error"
                                            : inputState.during_construction_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.during_construction_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.during_construction_period}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="During DLP">
                                    <label
                                        htmlFor="during_dlp_OM_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        During DLP <span className="required">*</span>
                                    </label>
                                    <input
                                        id="during_dlp_OM_period"
                                        type="number"
                                        min={0}
                                        name="during_dlp_OM_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Number of months"
                                        onChange={handleInputChange}
                                        value={formData.during_dlp_OM_period}
                                        className={`form-input ${errors.during_dlp_OM_period
                                            ? "error"
                                            : inputState.during_dlp_OM_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.during_dlp_OM_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.during_dlp_OM_period}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Rates">
                                    <label
                                        htmlFor="rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Rates<span className="required">*</span>
                                    </label>
                                    <input
                                        id="rate"
                                        type="number"
                                        min={0}
                                        name="rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate"
                                        onChange={handleInputChange}
                                        value={formData.rate}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteITransportation = ({ i, getTransportation }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqtransportupdate/${i.id}/`

            );

            if (res.status === 200) {
                await getTransportation();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success('Transportation BOQ data deleted successfully.')

            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Transportation" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Transportation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.vehicle_description}"</h1>

                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// *************************************************************************


// const AddEmployeeBOQ = ({ id, getEmployee }) => {

//     const [show, setShow] = useState(false);
//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         getEmployeeData();
//         setShow(true);
//     }

//     const [formData, setFormData] = useState({
//         empcode:"",
//         professional_type: "",
//         rate: "",
//         MM_construction_period: "",
//         MM_OM_period: "",
//         project: id,
//         eot: "",

//     });



//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});
//     const [employeeList, setEmployeeList] = useState([]);
//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = [
//             "empcode",
//             "MM_construction_period",
//             "MM_OM_period",
//             "rate",
//         ];
//         requiredFields.forEach((field) => {
//             if (!formData[field]) {
//                 newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
//                     } is required !`;
//             }
//         });

//         setErrors(newErrors);

//         return Object.keys(newErrors).length === 0;
//     };

//     const [loading, setLoading] = useState(false); //loading logic
//     const getEmployeeData = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/employeebyfilterss/${id}/null/null/null/null/`);
//             setEmployeeList(res.data);
//         } catch (err) { }
//     };



//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.post(
//                     `${BASE_URL}/siteproject/boqemployee/`,
//                     formData
//                 );

//                 if (res.status === 200) {
//                     await getEmployee();
//                     setShow(false);
//                     window.location.reload();
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err);
//             } finally {
//                 setLoading(false); //loading logic
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         setInputState({
//             ...inputState,
//             [name]: value.trim() ? "green" : "",
//         });

//         // For empcode, ensure it's handled as an array
//         if (name === "empcode") {
//             setFormData({
//                 ...formData,
//                 [name]: [value], // Wrap the selected value in an array
//             });
//         } else {
//             setFormData({
//                 ...formData,
//                 [name]: value,
//             });
//         }
//     };



//     return (
//         <>
//             <button title="Transportation" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Employee
//             </button>
//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="request-leave width-40vw"
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Employee BOQ</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             <div title="Employee" className="flex-column form-group-selectt">
//                                 <label htmlFor="empcode" className="form-labels  font-weight500    font-size-subheading">
//                                     Employee<span className="required">*</span>
//                                 </label>
//                                 <br />
//                                 <select
//                                     id="empcode"
//                                     name="empcode"
//                                     placeholder="empcode"
//                                     value={formData.empcode[0] || "null"} // Access the first element of the array or set "null"
//                                     onChange={handleInputChange}
//                                     className={`form-input form-group-selection ${errors.empcode ? "error" : inputState.empcode ? "success" : ""}`}
//                                 >
//                                     <option value="null">Select an Employee</option>
//                                     {employeeList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
//                                         <option key={index} value={i.emp_code}>{i.emp_code} {i.name}</option>
//                                     ))}
//                                 </select>

//                                 <div className="form-group-selection-arrow">
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="20"
//                                         height="25"
//                                         fill="currentColor"
//                                         className="bi bi-caret-down-fill"
//                                         viewBox="0 0 16 16"
//                                     >
//                                         <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
//                                     </svg>
//                                 </div>
//                                 {errors.empcode && <span className="error-message font-size-text ">{errors.empcode}</span>}
//                             </div>

//                             <div className="flex-column">
//                                 <label
//                                     htmlFor="MM_construction_period"
//                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                 >
//                                     Duration Construction Period{" "}
//                                     <span className="required">*</span>
//                                 </label>
//                                 <input
//                                     id="MM_construction_period"
//                                     type="number"
//                                     name="MM_construction_period"
//                                     onWheel={(e) => e.target.blur()}

//                                     placeholder="Construction Period"
//                                     onChange={handleInputChange}
//                                     value={formData.MM_construction_period}
//                                     className={`form-input ${errors.MM_construction_period
//                                         ? "error"
//                                         : inputState.MM_construction_period
//                                             ? "success"
//                                             : ""
//                                         }`}
//                                 />
//                                 {errors.MM_construction_period && (
//                                     <span className="error-message font-size-text ">
//                                         {errors.MM_construction_period}
//                                     </span>
//                                 )}
//                             </div>
//                             <div className="flex-column">
//                                 <label
//                                     htmlFor="MM_OM_period"
//                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                 >
//                                     Duration OM Period{" "}
//                                     <span className="required">*</span>
//                                 </label>
//                                 <input
//                                     id="MM_OM_period"
//                                     type="number"
//                                     name="MM_OM_period"
//                                     onWheel={(e) => e.target.blur()}

//                                     placeholder="OM Period"
//                                     onChange={handleInputChange}
//                                     value={formData.MM_OM_period}
//                                     className={`form-input ${errors.MM_OM_period
//                                         ? "error"
//                                         : inputState.MM_OM_period
//                                             ? "success"
//                                             : ""
//                                         }`}
//                                 />
//                                 {errors.MM_OM_period && (
//                                     <span className="error-message font-size-text ">
//                                         {errors.MM_OM_period}
//                                     </span>
//                                 )}
//                             </div>
//                             <div className="flex-column">
//                                 <label
//                                     htmlFor="rate"
//                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                 >
//                                     Rates<span className="required">*</span>
//                                 </label>
//                                 <input
//                                     id="rate"
//                                     type="number"
//                                     min={0}
//                                     name="rate"
//                                     onWheel={(e) => e.target.blur()}

//                                     placeholder="Rate"
//                                     onChange={handleInputChange}
//                                     value={formData.rate}
//                                     className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
//                                         }`}
//                                 />
//                                 {errors.rate && (
//                                     <span className="error-message font-size-text ">
//                                         {errors.rate}
//                                     </span>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                     <div className="button-models">
//                         <button
//                             className="model-button-cancel model-button   font-weight500   "
//                             onClick={handleClose}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="submit"
//                             className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
//                             onClick={handleSubmit}
//                             disabled={loading}
//                         >
//                             Add
//                         </button>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>

//         </>
//     )
// }

const AddEmployeeBOQ = ({ id, getEmployee }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setFormData({
            empcode: [],
            designation: "",
            professional_type: "",
            rate: "",
            MM_construction_period: "",
            MM_OM_period: "",
            project: id,
            eot: "",
        })
    }
    const handleShow = () => {
        getEmployeeData();
        setShow(true);
    };

    const [formData, setFormData] = useState({
        empcode: [],
        designation: "",
        professional_type: "",
        rate: "",
        MM_construction_period: "",
        MM_OM_period: "",
        project: id,
        eot: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [employeeList, setEmployeeList] = useState([]);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "empcode",
            "MM_construction_period",
            "MM_OM_period",
            "rate",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); // loading logic
    const getEmployeeData = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/employeebyfilterss/${id}/null/null/null/null/`
            );
            setEmployeeList(res.data);
        } catch (err) {
            console.error("Failed to fetch employee data", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); // loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); // toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqemployee/`,
                    formData
                );

                if (res.status === 200) {
                    await getEmployee();
                    toast.dismiss(loadingToastId);
                    handleClose();
                    toast.success(" Employee BOQ Added successfully!");


                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err); // toast Logic
            } finally {
                setLoading(false); // loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        if (name === "empcode") {
            // Find selected employee details
            const selectedEmployee = employeeList.find(emp => emp.emp_code === value);

            setFormData({
                ...formData,
                empcode: value ? [value] : [], // Store empcode as an array
                designation: selectedEmployee?.designation || "",
                professional_type: selectedEmployee?.professional_type || "",
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    return (
        <>
            <button title="Transportation" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /> Employee
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Employee BOQ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div title="Employee" className="flex-column form-group-selectt">
                                <label htmlFor="empcode" className="form-labels font-weight500 font-size-subheading">
                                    Employee<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="empcode"
                                    name="empcode"
                                    placeholder="empcode"
                                    value={formData.empcode[0] || "null"} // Access the first element or set "null"
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.empcode ? "error" : inputState.empcode ? "success" : ""}`}
                                >
                                    <option value="null">Select an Employee</option>
                                    {employeeList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.emp_code}>
                                            {i.emp_code} {i.name}
                                        </option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.empcode && <span className="error-message font-size-text">{errors.empcode}</span>}
                            </div>


                            <div className="flex-column">
                                <label
                                    htmlFor="MM_construction_period"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Duration Construction Period{" "}
                                    <span className="required">*</span>
                                </label>
                                <input
                                    id="MM_construction_period"
                                    type="number"
                                    name="MM_construction_period"
                                    onWheel={(e) => e.target.blur()}

                                    placeholder="Construction Period"
                                    onChange={handleInputChange}
                                    value={formData.MM_construction_period}
                                    className={`form-input ${errors.MM_construction_period
                                        ? "error"
                                        : inputState.MM_construction_period
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.MM_construction_period && (
                                    <span className="error-message font-size-text ">
                                        {errors.MM_construction_period}
                                    </span>
                                )}
                            </div>
                            <div className="flex-column">
                                <label
                                    htmlFor="MM_OM_period"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Duration OM Period{" "}
                                    <span className="required">*</span>
                                </label>
                                <input
                                    id="MM_OM_period"
                                    type="number"
                                    name="MM_OM_period"
                                    onWheel={(e) => e.target.blur()}

                                    placeholder="OM Period"
                                    onChange={handleInputChange}
                                    value={formData.MM_OM_period}
                                    className={`form-input ${errors.MM_OM_period
                                        ? "error"
                                        : inputState.MM_OM_period
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.MM_OM_period && (
                                    <span className="error-message font-size-text ">
                                        {errors.MM_OM_period}
                                    </span>
                                )}
                            </div>
                            <div className="flex-column">
                                <label
                                    htmlFor="rate"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Rates<span className="required">*</span>
                                </label>
                                <input
                                    id="rate"
                                    type="number"
                                    min={0}
                                    name="rate"
                                    onWheel={(e) => e.target.blur()}

                                    placeholder="Rate"
                                    onChange={handleInputChange}
                                    value={formData.rate}
                                    className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                        }`}
                                />
                                {errors.rate && (
                                    <span className="error-message font-size-text ">
                                        {errors.rate}
                                    </span>
                                )}
                            </div>

                            {/* Other input fields */}
                            {/* Construction Period, OM Period, and Rate inputs */}
                        </div>
                    </div>
                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Add
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const UpdateEmployeeBOQ = ({ i, id, getEmployee }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => { setShow(false); }
    const handleShow = () => {
        getEmployeeData();
        setShow(true);
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        empcode: [],
        designation: "",
        professional_type: "",
        rate: "",
        MM_construction_period: "",
        MM_OM_period: "",
        project: id,
        eot: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [employeeList, setEmployeeList] = useState([]);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "empcode",
            "MM_construction_period",
            "MM_OM_period",
            "rate",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); // loading logic
    const getEmployeeData = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/employeebyfilterss/${id}/null/null/null/null/`
            );
            setEmployeeList(res.data);
        } catch (err) {
            console.error("Failed to fetch employee data", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); // loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); // toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqemployeeupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getEmployee();
                    toast.dismiss(loadingToastId);
                    handleClose();
                    toast.success(" Employee BOQ Updated successfully!");

                    // window.location.reload();

                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err); // toast Logic
            } finally {
                setLoading(false); // loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        if (name === "empcode") {
            // Find selected employee details
            const selectedEmployee = employeeList.find(emp => emp.emp_code === value);

            setFormData({
                ...formData,
                empcode: value ? [value] : [], // Store empcode as an array
                designation: selectedEmployee?.designation || "",
                professional_type: selectedEmployee?.professional_type || "",
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    return (
        <>
            <button title="Employee BOQ" className="model-edit-button" onClick={handleShow}>
                <UpdatePencil />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Employee BOQ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="parent-div">
                            <div className="bdy-div">
                                <div title="Employee" className="flex-column form-group-selectt">
                                    <label htmlFor="empcode" className="form-labels font-weight500 font-size-subheading">
                                        Employee<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="empcode"
                                        name="empcode"
                                        placeholder="empcode"
                                        value={formData.empcode[0] || "null"} // Access the first element or set "null"
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.empcode ? "error" : inputState.empcode ? "success" : ""}`}
                                    >
                                        <option value="null">Select an Employee</option>
                                        {employeeList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                            <option key={index} value={i.emp_code}>
                                                {i.emp_code} {i.name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            className="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    {errors.empcode && <span className="error-message font-size-text">{errors.empcode}</span>}
                                </div>


                                <div className="flex-column">
                                    <label
                                        htmlFor="MM_construction_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Duration Construction Period{" "}
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        id="MM_construction_period"
                                        type="number"
                                        name="MM_construction_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Construction Period"
                                        onChange={handleInputChange}
                                        value={formData.MM_construction_period}
                                        className={`form-input ${errors.MM_construction_period
                                            ? "error"
                                            : inputState.MM_construction_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.MM_construction_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.MM_construction_period}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="MM_OM_period"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Duration OM Period{" "}
                                        <span className="required">*</span>
                                    </label>
                                    <input
                                        id="MM_OM_period"
                                        type="number"
                                        name="MM_OM_period"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="OM Period"
                                        onChange={handleInputChange}
                                        value={formData.MM_OM_period}
                                        className={`form-input ${errors.MM_OM_period
                                            ? "error"
                                            : inputState.MM_OM_period
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.MM_OM_period && (
                                        <span className="error-message font-size-text ">
                                            {errors.MM_OM_period}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Rates<span className="required">*</span>
                                    </label>
                                    <input
                                        id="rate"
                                        type="number"
                                        min={0}
                                        name="rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate"
                                        onChange={handleInputChange}
                                        value={formData.rate}
                                        className={`form-input ${errors.rate ? "error" : inputState.rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                                {/* Other input fields */}
                                {/* Construction Period, OM Period, and Rate inputs */}
                            </div>
                        </div>
                        <div className="button-models">
                            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
                                disabled={loading}
                            >
                                Update
                            </button>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const DeleteEmployeeBOQ = ({ i, getEmployee }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqemployeeupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getEmployee();
                toast.dismiss(loadingToastId);
                handleClose();
                toast.success(" Employee BOQ Deleted successfully!");
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Transportation" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Employee BOQ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete Employee BOQ of "{i.employee_name_details[0].name}"</h1>

                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};





const AddDutyTravel = ({ id, getDutyTravel, logData, dutytravelList }) => {
    const [show, setShow] = useState(false);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleClose = () => {
        setShow(false);
        setFormData({
            trips: "",
            num_of_min_trip: "",
            during_dlp_OM_period: 0,
            during_construction_period: 0,
            rate_per_trip: "",
            project: id,
            random_value_of_changes: "",
            reason_of_change: "",
            eot_details: eotObjects.length > 0 ? eotObjects : [],


        })
    };
    const handleShow = () => setShow(true);
    const [eotObjects, setEotObjects] = useState([]);

    const [formData, setFormData] = useState({
        trips: "",
        num_of_min_trip: "",
        during_dlp_OM_period: 0,
        during_construction_period: 0,
        rate_per_trip: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: "",
        eot_details: eotObjects.length > 0 ? eotObjects : [],



        // sub_company: sessionStorage.getItem('company_id')
    });


    useEffect(() => {
        if (Array.isArray(dutytravelList) && dutytravelList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = dutytravelList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    rate: 0,
                    t_trips: 0,
                    total_amount: 0,

                    boqId: dutytravelList[0].id, // or keep it dynamic
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [dutytravelList]);


    useEffect(() => {


        if (dutytravelList.length === 0) return;

        const anyReasonFilled = dutytravelList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );


        if (anyReasonFilled) {
            const latestRandom = [...dutytravelList]
                .filter(item => item.random_value_of_changes)
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = dutytravelList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }

    }, [dutytravelList]);




    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["trips", "num_of_min_trip", "rate_per_trip",];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqtravel/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getDutyTravel();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Duty Travel" className="upload-svg flex-row" onClick={handleShow}>
    //             <AddwithWhiteCircle />
    //             {" "} Duty Travel
    //         </button>
    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Duty Travel</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">


    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="trips"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Trips"
    //                                 >
    //                                     Description of Trip<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="trips"
    //                                     type="text"
    //                                     name="trips"
    //                                     title="Trips"
    //                                     placeholder="Trips"
    //                                     onChange={handleInputChange}
    //                                     value={formData.trips}
    //                                     className={`form-input ${errors.trips
    //                                         ? "error"
    //                                         : inputState.trips
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.trips && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.trips}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="num_of_min_trip"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     Total Number of Trips<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="num_of_min_trip"
    //                                     type="number"
    //                                     name="num_of_min_trip"
    //                                     title="Total Number of Trips"
    //                                     onWheel={(e) => e.target.blur()}
    //                                     placeholder="Total Number of Trips"
    //                                     onChange={handleInputChange}
    //                                     value={formData.num_of_min_trip}
    //                                     className={`form-input ${errors.num_of_min_trip ? "error" : inputState.num_of_min_trip ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.num_of_min_trip && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.num_of_min_trip}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="rate_per_trip"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate per Trips"
    //                                 >
    //                                     Rate per Trip (Rs.)<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="rate_per_trip"
    //                                     type="number"
    //                                     min={0}
    //                                     title="Rate per Trip"
    //                                     name="rate_per_trip"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Rate per Trip"
    //                                     onChange={handleInputChange}
    //                                     value={formData.rate_per_trip}
    //                                     className={`form-input ${errors.rate_per_trip ? "error" : inputState.rate_per_trip ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.rate_per_trip && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.rate_per_trip}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );


    return (
        <>
            <button
                title="Add Duty Travel BOQ"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <AddwithWhiteCircle />
                Duty Travel
            </button>
            {showProgressModal ?
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :

                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <AddwithWhiteCircle />
                            Add Duty Travel
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">

                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* Description of Trip */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="trips" className="eb-bulk-th-label" title="Trips">
                                                Description of Trip <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="trips"
                                                type="text"
                                                name="trips"
                                                title="Trips"
                                                placeholder="Enter trip description"
                                                onChange={handleInputChange}
                                                value={formData.trips}
                                                className={`eb-bulk-input ${errors.trips ? "eb-bulk-input-error" : ""}`}
                                                style={{ textAlign: "start" }}
                                            />
                                            {errors.trips && (
                                                <span className="eb-bulk-error-text">{errors.trips}</span>
                                            )}
                                        </div>
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="num_of_min_trip" className="eb-bulk-th-label" title="Number of Minimum Trips">
                                                Total Number of Trips <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="num_of_min_trip"
                                                type="number"
                                                name="num_of_min_trip"
                                                title="Total Number of Trips"
                                                onWheel={(e) => e.target.blur()}
                                                style={{ width: "94%", textAlign: "start" }}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.num_of_min_trip}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.num_of_min_trip ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.num_of_min_trip && (
                                                <span className="eb-bulk-error-text">{errors.num_of_min_trip}</span>
                                            )}
                                        </div>

                                        {/* Rate per Trip */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="rate_per_trip" className="eb-bulk-th-label" title="Rate per Trips">
                                                Rate per Trip (Rs.) <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="rate_per_trip"
                                                type="number"
                                                style={{ width: "94%" }}

                                                min={0}
                                                title="Rate per Trip"
                                                name="rate_per_trip"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.rate_per_trip}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.rate_per_trip ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.rate_per_trip && (
                                                <span className="eb-bulk-error-text">{errors.rate_per_trip}</span>
                                            )}
                                        </div>
                                        {/* Total Number of Trips */}


                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>

                            </div>
                        </div>
                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            }

        </>
    );
};


const UpdateDutyTravel = ({ i, getDutyTravel }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        trips: "",
        num_of_min_trip: "",
        rate_per_trip: "",
        project: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["trips", "num_of_min_trip", "rate_per_trip"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqtravelupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getDutyTravel();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Duty Travel"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Duty Travel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            <form>
                                <div className="flex-column" title="Trips">
                                    <label
                                        htmlFor="trips"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Trips<span className="required">*</span>
                                    </label>
                                    <input
                                        id="trips"
                                        type="trips"
                                        name="trips"

                                        placeholder="Trips"
                                        onChange={handleInputChange}
                                        value={formData.trips}
                                        className={`form-input ${errors.trips
                                            ? "error"
                                            : inputState.trips
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.trips && (
                                        <span className="error-message font-size-text ">
                                            {errors.trips}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Number of Minimum Trips">
                                    <label
                                        htmlFor="num_of_min_trip"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Number of minimum Trips<span className="required">*</span>
                                    </label>
                                    <input
                                        id="num_of_min_trip"
                                        type="num_of_min_trip"
                                        name="num_of_min_trip"

                                        placeholder="Number of minimum Trips"
                                        onChange={handleInputChange}
                                        value={formData.num_of_min_trip}
                                        className={`form-input ${errors.num_of_min_trip ? "error" : inputState.num_of_min_trip ? "success" : ""
                                            }`}
                                    />
                                    {errors.num_of_min_trip && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_min_trip}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Rate Per Item">
                                    <label
                                        htmlFor="rate_per_trip"
                                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    >
                                        Rate per Trip (Rs.)<span className="required">*</span>
                                    </label>
                                    <input
                                        id="rate_per_trip"
                                        type="number"
                                        min={0}
                                        name="rate_per_trip"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder=" Rate per Trip"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_trip}
                                        className={`form-input ${errors.rate_per_trip ? "error" : inputState.rate_per_trip ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate}
                                        </span>
                                    )}
                                </div>

                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteIDutyTravel = ({ i, getDutyTravel }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqtravelupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getDutyTravel();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Duty travel BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Duty Travel" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Duty travels</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.trips}"</h1>


                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************


const AddOfficeRent = ({ id, getOfficeRent, officeRentList, logData }) => {
    const [show, setShow] = useState(false);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [eotObjects, setEotObjects] = useState([]);

    const handleClose = () => {
        setShow(false);
        setFormData({
            num_of_months: "",
            rate_per_month: "",
            during_construction_period: "",
            during_dlp_OM_period: "",
            project: id,
            random_value_of_changes: "",
            reason_of_change: "",
            eot_details: eotObjects.length > 0 ? eotObjects : [],

        })
    }
    const handleShow = () => { setShow(true) };

    const [formData, setFormData] = useState({
        num_of_months: "",
        rate_per_month: "",
        during_construction_period: "",
        during_dlp_OM_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: "",
        eot_details: eotObjects.length > 0 ? eotObjects : [],


        // sub_company: sessionStorage.getItem('company_id')
    });

    useEffect(() => {
        if (Array.isArray(officeRentList) && officeRentList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = officeRentList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    cp: 0,
                    dlp: 0,
                    rate: 0,
                    t_month: 0,
                    boqId: officeRentList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [officeRentList]);


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            num_of_months: Number(formData.during_construction_period) + Number(formData.during_dlp_OM_period),
        }))
    }, [formData.during_construction_period, formData.during_dlp_OM_period])

    useEffect(() => {


        if (officeRentList.length === 0) return;

        const anyReasonFilled = officeRentList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );


        if (anyReasonFilled) {
            const latestRandom = [...officeRentList]
                .filter(item => item.random_value_of_changes)
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = officeRentList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }

    }, [officeRentList]);


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["rate_per_month", 'during_construction_period', 'during_dlp_OM_period'];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqofficerent/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getOfficeRent();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000);
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Office Rent" className="upload-svg flex-row" onClick={handleShow}>
    //             <AddwithWhiteCircle />
    //             {" "} Office Rent
    //         </button>

    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Office Rent</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">
    //                         {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="during_construction_period"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     During Construction Period<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="during_construction_period"
    //                                     type="number"
    //                                     name="during_construction_period"
    //                                     title="During Construction Period"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Construction Period Duration"
    //                                     onChange={handleInputChange}
    //                                     value={formData.during_construction_period}
    //                                     className={`form-input ${errors.during_construction_period ? "error" : inputState.during_construction_period ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.during_construction_period && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.during_construction_period}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="during_dlp_OM_period"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     During O&M Period<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="during_dlp_OM_period"
    //                                     type="number"
    //                                     name="during_dlp_OM_period"
    //                                     title="During O&M Period"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="During O&M Period"
    //                                     onChange={handleInputChange}
    //                                     value={formData.during_dlp_OM_period}
    //                                     className={`form-input ${errors.during_dlp_OM_period ? "error" : inputState.during_dlp_OM_period ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.during_dlp_OM_period && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.during_dlp_OM_period}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="num_of_months"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="No. of Months"
    //                                 >
    //                                     No. of Months<span className="required">(Read-Only)</span>
    //                                 </label>
    //                                 <input
    //                                     id="num_of_months"
    //                                     type="number"
    //                                     title="No. of Months"
    //                                     onWheel={(e) => e.target.blur()}
    //                                     name="num_of_months"
    //                                     readOnly
    //                                     placeholder="No. of Months"
    //                                     onChange={handleInputChange}
    //                                     value={formData.num_of_months}
    //                                     className={`form-input ${errors.num_of_months
    //                                         ? "error"
    //                                         : inputState.num_of_months
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.num_of_months && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.num_of_months}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="rate_per_month"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Rate / Month (Rs.)"
    //                                 >
    //                                     Rate / Month (Rs.)<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="rate_per_month"
    //                                     type="number"
    //                                     title="Rate / Month (Rs.)"
    //                                     name="rate_per_month"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Rate"
    //                                     onChange={handleInputChange}
    //                                     value={formData.rate_per_month}
    //                                     className={`form-input ${errors.rate_per_month ? "error" : inputState.rate_per_month ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.rate_per_month && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.rate_per_month}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );

    return (
        <>
            <button
                title="Add Office Rent BOQ"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <Building />
                Add Office Rent
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <Building />
                            Add Office Rent
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* During Construction Period */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="during_construction_period" className="eb-bulk-th-label" title="During Construction Period">
                                                During Construction Period <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="during_construction_period"
                                                type="number"
                                                name="during_construction_period"
                                                title="During Construction Period"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.during_construction_period}
                                                style={{ width: "94%" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.during_construction_period ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.during_construction_period && (
                                                <span className="eb-bulk-error-text">{errors.during_construction_period}</span>
                                            )}
                                        </div>

                                        {/* During O&M Period */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="during_dlp_OM_period" className="eb-bulk-th-label" title="During O&M Period">
                                                During O&M Period <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="during_dlp_OM_period"
                                                type="number"
                                                name="during_dlp_OM_period"
                                                title="During O&M Period"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.during_dlp_OM_period}
                                                style={{ width: "94%" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.during_dlp_OM_period ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.during_dlp_OM_period && (
                                                <span className="eb-bulk-error-text">{errors.during_dlp_OM_period}</span>
                                            )}
                                        </div>

                                        {/* No. of Months (Read-Only) */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="num_of_months" className="eb-bulk-th-label" title="No. of Months">
                                                No. of Months <span className="eb-bulk-required">(Read-Only)</span>
                                            </label>
                                            <input
                                                id="num_of_months"
                                                type="number"
                                                name="num_of_months"
                                                title="No. of Months"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                readOnly
                                                value={formData.num_of_months}
                                                style={{ width: "94%", background: "var(--eb-bulk-input-readonly-bg, #f5f5f5)", cursor: "not-allowed" }}
                                                className="eb-bulk-input eb-bulk-input-number"
                                            />
                                        </div>

                                        {/* Rate per Month */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="rate_per_month" className="eb-bulk-th-label" title="Rate / Month (Rs.)">
                                                Rate / Month (Rs.) <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="rate_per_month"
                                                type="number"
                                                name="rate_per_month"
                                                title="Rate / Month (Rs.)"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.rate_per_month}
                                                style={{ width: "94%" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.rate_per_month ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.rate_per_month && (
                                                <span className="eb-bulk-error-text">{errors.rate_per_month}</span>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};


const UpdateOfficeRent = ({ i, getOfficeRent }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        num_of_months: "",
        rate_per_month: "",
        project: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["num_of_months", "rate_per_month"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqofficerentupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeRent();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Office Rent"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Office Rent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column" title="No. of Months">
                                    <label
                                        htmlFor="num_of_months"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        No. of Months<span className="required">*</span>
                                    </label>
                                    <input
                                        id="num_of_months"
                                        type="number"
                                        name="num_of_months"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="No. of Months"
                                        onChange={handleInputChange}
                                        value={formData.num_of_months}
                                        className={`form-input ${errors.num_of_months
                                            ? "error"
                                            : inputState.num_of_months
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.num_of_months && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_months}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Rate/Month(Rs.)">
                                    <label
                                        htmlFor="rate_per_month"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Rate / Month (Rs.)<span className="required">*</span>
                                    </label>
                                    <input
                                        id="rate_per_month"
                                        type="number"
                                        name="rate_per_month"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate / Month"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_month}
                                        className={`form-input ${errors.rate_per_month ? "error" : inputState.rate_per_month ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate_per_month && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate_per_month}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteOfficeRent = ({ i, getOfficeRent }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqofficerentupdate/${i.id}/`

            );

            if (res.status === 200) {
                await getOfficeRent();
                handleClose();
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Office Rent BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Office Rent" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Office Rent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete for "{i.num_of_months}" Months </h1>

                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************

const AddOfficeSupplies = ({ id, getOfficeSupplies, officeSuppliesList, logData }) => {
    const [show, setShow] = useState(false);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [eotObjects, setEotObjects] = useState([]);

    const handleClose = () => {
        setShow(false);
        setFormData({
            item: "",
            months: "",
            monthly_rate: "",
            during_construction_period: "",
            during_dlp_OM_period: "",
            project: id,
            random_value_of_changes: "",
            eot_details: eotObjects.length > 0 ? eotObjects : [],

            reason_of_change: "",

        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        item: "",
        months: "",
        monthly_rate: "",
        during_construction_period: "",
        during_dlp_OM_period: "",
        project: id,
        random_value_of_changes: "",
        eot_details: eotObjects.length > 0 ? eotObjects : [],

        reason_of_change: "",

        // sub_company: sessionStorage.getItem('company_id')
    });




    useEffect(() => {
        if (Array.isArray(officeSuppliesList) && officeSuppliesList.length > 0) {
            // take the first item (or any item) and check its eot_details length
            const eotLength = officeSuppliesList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {
                // create n empty EOT objects
                const newEots = Array.from({ length: eotLength }, (_, index) => ({
                    cp: 0,
                    dlp: 0,
                    rate: 0,
                    t_month: 0,
                    boqId: officeSuppliesList[0].id, // or keep it dynamic
                    total_amount: 0,
                }));

                setEotObjects(newEots);
                setFormData((prev) => ({
                    ...prev,
                    eot_details: newEots
                }))
            }
        }
    }, [officeSuppliesList]);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            months: Number(formData.during_construction_period) + Number(formData.during_dlp_OM_period),
        }))
    }, [formData.during_construction_period, formData.during_dlp_OM_period])

    useEffect(() => {


        if (officeSuppliesList.length === 0) return;

        const anyReasonFilled = officeSuppliesList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );


        if (anyReasonFilled) {
            const latestRandom = [...officeSuppliesList]
                .filter(item => item.random_value_of_changes)
                .sort((a, b) => new Date(b.random_value_of_changes) - new Date(a.random_value_of_changes))[0];

            if (latestRandom?.random_value_of_changes) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: latestRandom.random_value_of_changes,
                    reason_of_change: latestRandom.reason_of_change || "",
                }));
            }
        } else {
            const existingRandom = officeSuppliesList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" || item.reason_of_change === null || item.reason_of_change === "")
            );

            if (existingRandom) {
                setFormData((prev) => ({
                    ...prev,
                    random_value_of_changes: existingRandom.random_value_of_changes,
                    reason_of_change: existingRandom.reason_of_change || "",
                }));
            }
        }

    }, [officeSuppliesList]);


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item", "months", "monthly_rate", 'during_dlp_OM_period', 'during_construction_period'];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/boqofficesupplies/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 200) {
                    await getOfficeSupplies();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // return (
    //     <>
    //         <button title="Office Supplies" className="upload-svg flex-row" onClick={handleShow}>
    //             <AddwithWhiteCircle />
    //             {" "} Office Supplies
    //         </button>

    //         <Modal
    //             show={show}
    //             onHide={handleClose}
    //             dialogClassName="request-leave width-40vw"
    //         >
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Office Supplies</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div">
    //                         {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

    //                         <form>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="item"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Item"
    //                                 >
    //                                     Item<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="item"
    //                                     type="text"
    //                                     name="item"
    //                                     title="Itme"
    //                                     placeholder="Item Name"
    //                                     onChange={handleInputChange}
    //                                     value={formData.item}
    //                                     className={`form-input ${errors.item
    //                                         ? "error"
    //                                         : inputState.item
    //                                             ? "success"
    //                                             : ""
    //                                         }`}
    //                                 />
    //                                 {errors.item && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.item}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="during_construction_period"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     During Construction Period<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="during_construction_period"
    //                                     type="number"
    //                                     name="during_construction_period"
    //                                     title="During Construction Period"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Construction Period Duration"
    //                                     onChange={handleInputChange}
    //                                     value={formData.during_construction_period}
    //                                     className={`form-input ${errors.during_construction_period ? "error" : inputState.during_construction_period ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.during_construction_period && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.during_construction_period}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="during_dlp_OM_period"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Number of Minimum Trips"
    //                                 >
    //                                     During O&M Period<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="during_dlp_OM_period"
    //                                     type="number"
    //                                     name="during_dlp_OM_period"
    //                                     title="During O&M Period"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="During O&M Period"
    //                                     onChange={handleInputChange}
    //                                     value={formData.during_dlp_OM_period}
    //                                     className={`form-input ${errors.during_dlp_OM_period ? "error" : inputState.during_dlp_OM_period ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.during_dlp_OM_period && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.during_dlp_OM_period}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="months"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Months"
    //                                 >
    //                                     Total Months<span className="required">(Read-Only)</span>
    //                                 </label>
    //                                 <input
    //                                     id="months"
    //                                     type="number"
    //                                     title="Total Months"
    //                                     placeholder="Total Months"
    //                                     name="months"
    //                                     readOnly
    //                                     onWheel={(e) => e.target.blur()}
    //                                     onChange={handleInputChange}
    //                                     value={formData.months}
    //                                     className={`form-input ${errors.months ? "error" : inputState.months ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.months && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.months}
    //                                     </span>
    //                                 )}
    //                             </div>

    //                             <div className="flex-column">
    //                                 <label
    //                                     htmlFor="monthly_rate"
    //                                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading" title="Monthly Rate"
    //                                 >
    //                                     Monthly Rate<span className="required">*</span>
    //                                 </label>
    //                                 <input
    //                                     id="monthly_rate"
    //                                     type="number"
    //                                     title="Monthly Rate"
    //                                     min={0}
    //                                     name="monthly_rate"
    //                                     onWheel={(e) => e.target.blur()}

    //                                     placeholder="Monthly Rate"
    //                                     onChange={handleInputChange}
    //                                     value={formData.monthly_rate}
    //                                     className={`form-input ${errors.monthly_rate ? "error" : inputState.monthly_rate ? "success" : ""
    //                                         }`}
    //                                 />
    //                                 {errors.monthly_rate && (
    //                                     <span className="error-message font-size-text ">
    //                                         {errors.monthly_rate}
    //                                     </span>
    //                                 )}
    //                             </div>
    //                         </form>
    //                         <div className="button-models">
    //                             <button
    //                                 className="model-button-cancel model-button   font-weight500   "
    //                                 onClick={handleClose}
    //                             >
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
    //                                 onClick={handleSubmit}
    //                                 disabled={loading}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer
    //                     position="top-center"
    //                     autoClose={1000}
    //                     hideProgressBar={false}
    //                     newestOnTop={true}
    //                     closeOnClick
    //                     rtl={false}
    //                     pauseOnFocusLoss
    //                     draggable
    //                     pauseOnHover
    //                 />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );


    return (
        <>
            <button
                title="Office Supplies"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <Building2Icon />
                Office Supplies
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal request-leave width-40vw"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <AddwithWhiteCircle />
                            Add Office Supplies
                            <button className="close-btn" style={{ top: "19px" }} onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll" style={{ margin: "0px 10px" }}>

                                        {/* Item */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="item" className="eb-bulk-th-label" title="Item">
                                                Item <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="item"
                                                type="text"
                                                name="item"
                                                title="Item"
                                                placeholder="Item Name"
                                                onChange={handleInputChange}
                                                value={formData.item}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input ${errors.item ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.item && (
                                                <span className="eb-bulk-error-text">{errors.item}</span>
                                            )}
                                        </div>

                                        {/* During Construction Period */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="during_construction_period" className="eb-bulk-th-label" title="During Construction Period">
                                                During Construction Period <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="during_construction_period"
                                                type="number"
                                                name="during_construction_period"
                                                title="During Construction Period"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.during_construction_period}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.during_construction_period ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.during_construction_period && (
                                                <span className="eb-bulk-error-text">{errors.during_construction_period}</span>
                                            )}
                                        </div>

                                        {/* During O&M Period */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="during_dlp_OM_period" className="eb-bulk-th-label" title="During O&M Period">
                                                During O&M Period <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="during_dlp_OM_period"
                                                type="number"
                                                name="during_dlp_OM_period"
                                                title="During O&M Period"
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="0"
                                                onChange={handleInputChange}
                                                value={formData.during_dlp_OM_period}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.during_dlp_OM_period ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.during_dlp_OM_period && (
                                                <span className="eb-bulk-error-text">{errors.during_dlp_OM_period}</span>
                                            )}
                                        </div>

                                        {/* Total Months (Read-Only) */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="months" className="eb-bulk-th-label" title="Total Months">
                                                Total Months <span className="eb-bulk-required">(Read-Only)</span>
                                            </label>
                                            <input
                                                id="months"
                                                type="number"
                                                name="months"
                                                title="Total Months"
                                                placeholder="0"
                                                readOnly
                                                onWheel={(e) => e.target.blur()}
                                                value={formData.months}
                                                style={{ width: "94%", textAlign: "start", background: "var(--eb-bulk-input-readonly-bg, #f5f5f5)", cursor: "not-allowed" }}
                                                className="eb-bulk-input eb-bulk-input-number"
                                            />
                                        </div>

                                        {/* Monthly Rate */}
                                        <div className="flex-column" style={{ marginBottom: "16px" }}>
                                            <label htmlFor="monthly_rate" className="eb-bulk-th-label" title="Monthly Rate">
                                                Monthly Rate <span className="eb-bulk-required">*</span>
                                            </label>
                                            <input
                                                id="monthly_rate"
                                                type="number"
                                                name="monthly_rate"
                                                title="Monthly Rate"
                                                min={0}
                                                onWheel={(e) => e.target.blur()}
                                                placeholder="₹ 0.00"
                                                onChange={handleInputChange}
                                                value={formData.monthly_rate}
                                                style={{ width: "94%", textAlign: "start" }}
                                                className={`eb-bulk-input eb-bulk-input-number ${errors.monthly_rate ? "eb-bulk-input-error" : ""}`}
                                            />
                                            {errors.monthly_rate && (
                                                <span className="eb-bulk-error-text">{errors.monthly_rate}</span>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};



const UpdateOfficeSupplies = ({ i, getOfficeSupplies }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        item: "",
        months: "",
        monthly_rate: "",
        project: "",
        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item", "months", "monthly_rate"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqofficesuppliesupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeSupplies();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Office Supplies"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Office Supplies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="item"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Item<span className="required">*</span>
                                    </label>
                                    <input
                                        id="item"
                                        type="text"
                                        name="item"

                                        placeholder="Item Name"
                                        onChange={handleInputChange}
                                        value={formData.item}
                                        className={`form-input ${errors.item
                                            ? "error"
                                            : inputState.item
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.item && (
                                        <span className="error-message font-size-text ">
                                            {errors.item}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="months"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Months<span className="required">*</span>
                                    </label>
                                    <input
                                        id="months"
                                        type="number"
                                        name="months"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="No. of Months"
                                        onChange={handleInputChange}
                                        value={formData.months}
                                        className={`form-input ${errors.months ? "error" : inputState.months ? "success" : ""
                                            }`}
                                    />
                                    {errors.months && (
                                        <span className="error-message font-size-text ">
                                            {errors.months}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="monthly_rate"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Monthly Rate<span className="required">*</span>
                                    </label>
                                    <input
                                        id="monthly_rate"
                                        type="number"
                                        name="monthly_rate"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Monthly Rate"
                                        onChange={handleInputChange}
                                        value={formData.monthly_rate}
                                        className={`form-input ${errors.monthly_rate ? "error" : inputState.monthly_rate ? "success" : ""
                                            }`}
                                    />
                                    {errors.monthly_rate && (
                                        <span className="error-message font-size-text ">
                                            {errors.monthly_rate}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteOfficeSupplies = ({ i, getOfficeSupplies }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqofficesuppliesupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getOfficeSupplies();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Office Supplies BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Office Supplies" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Office Supplies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete Item "{i.item}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************

const UpdateOfficeFurniture = ({ i, getOfficeFurniture }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        num_of_months: "",
        rate_per_month: "",
        project: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["num_of_months", "rate_per_month"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqofficefurnitureandequipmentupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeFurniture();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Office Furniture"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Office Furniture</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column" title="No. of Months">
                                    <label
                                        htmlFor="num_of_months"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        No. of month
                                    </label>
                                    <input
                                        id="num_of_months"
                                        type="number"
                                        name="num_of_months"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="No. of Month"
                                        onChange={handleInputChange}
                                        value={formData.num_of_months}
                                        className={`form-input ${errors.num_of_months
                                            ? "error"
                                            : inputState.num_of_months
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.num_of_months && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_months}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Rate per Month">
                                    <label
                                        htmlFor="rate_per_month"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Rate per Month
                                    </label>
                                    <input
                                        id="rate_per_month"
                                        type="number"
                                        name="rate_per_month"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate per Month"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_month}
                                        className={`form-input ${errors.rate_per_month ? "error" : inputState.rate_per_month ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate_per_month && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate_per_month}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteOfficeFurniture = ({ i, getOfficeFurniture }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqofficefurnitureandequipmentupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getOfficeFurniture();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Office Furniture BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Office Furniture" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Office Furniture</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete for "{i.num_of_months}" Months </h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************

const UpdateReportsPrinting = ({ i, getReportsPrinting }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        description: "",
        num_of_reports: "",
        num_of_copies_per_report: "",
        rate_per_copy: "",
        project: "",

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "num_of_reports", "num_of_copies_per_report", "rate_per_copy"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqreportsanddocprintupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getReportsPrinting();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Report & Doc"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Report & Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column" title="Description">
                                    <label
                                        htmlFor="description"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description
                                    </label>
                                    <input
                                        id="description"
                                        type="text"
                                        name="description"
                                        maxLength={300}
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text ">
                                            {errors.description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="No. of Reports">
                                    <label
                                        htmlFor="num_of_reports"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        No. of Reports
                                    </label>
                                    <input
                                        id="num_of_reports"
                                        type="number"
                                        name="num_of_reports"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="No. of Reports"
                                        onChange={handleInputChange}
                                        value={formData.num_of_reports}
                                        className={`form-input ${errors.num_of_reports ? "error" : inputState.num_of_reports ? "success" : ""
                                            }`}
                                    />
                                    {errors.num_of_reports && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_reports}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="No. of copies per Report">
                                    <label
                                        htmlFor="num_of_copies_per_report"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        No. of Copies per Report
                                    </label>
                                    <input
                                        id="num_of_copies_per_report"
                                        type="number"
                                        min={0}
                                        name="num_of_copies_per_report"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="No. of Copies per Report"
                                        onChange={handleInputChange}
                                        value={formData.num_of_copies_per_report}
                                        className={`form-input ${errors.num_of_copies_per_report ? "error" : inputState.num_of_copies_per_report ? "success" : ""
                                            }`}
                                    />
                                    {errors.num_of_copies_per_report && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_copies_per_report}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Rate per Copy">
                                    <label
                                        htmlFor="rate_per_copy"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Rate per Copy
                                    </label>
                                    <input
                                        id="rate_per_copy"
                                        type="number"
                                        min={0}
                                        name="rate_per_copy"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate per Copy"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_copy}
                                        className={`form-input ${errors.rate_per_copy
                                            ? "error"
                                            : inputState.rate_per_copy
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.rate_per_copy && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate_per_copy}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteReportsPrinting = ({ i, getReportsPrinting }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqreportsanddocprintupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getReportsPrinting();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Reports and Document BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Report & Doc" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Report & Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.description}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************

const UpdateRoadSurveyEquipment = ({ i, getRoadSurveyEquipment }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        KM: "",
        description: "",
        num_of_times_survey_concluded: "",
        rate_per_km_times: "",
        project: ""

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "num_of_times_survey_concluded", "rate_per_km_times"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqroadsurveyequipmentupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getRoadSurveyEquipment();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Road Survey"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Road Survey</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column" title="Description">
                                    <label
                                        htmlFor="description"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description
                                    </label>
                                    <input
                                        id="description"
                                        type="text"
                                        name="description"
                                        maxLength={300}
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text ">
                                            {errors.description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="KM">
                                    <label
                                        htmlFor="KM"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        KM
                                    </label>
                                    <input
                                        id="KM"
                                        type="number"
                                        min={0}
                                        name="KM"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="KM"
                                        onChange={handleInputChange}
                                        value={formData.KM}
                                        className={`form-input ${errors.KM ? "error" : inputState.KM ? "success" : ""
                                            }`}
                                    />
                                    {errors.KM && (
                                        <span className="error-message font-size-text ">
                                            {errors.KM}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="No. of times Survey Concluded">
                                    <label
                                        htmlFor="num_of_times_survey_concluded"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        No. of time survey concluded
                                    </label>
                                    <input
                                        id="num_of_times_survey_concluded"
                                        type="number"
                                        min={0}
                                        name="num_of_times_survey_concluded"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="No. of times Survey Concluded"
                                        onChange={handleInputChange}
                                        value={formData.num_of_times_survey_concluded}
                                        className={`form-input ${errors.num_of_times_survey_concluded ? "error" : inputState.num_of_times_survey_concluded ? "success" : ""
                                            }`}
                                    />
                                    {errors.num_of_times_survey_concluded && (
                                        <span className="error-message font-size-text ">
                                            {errors.num_of_times_survey_concluded}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column" title="Rate per No. of times Survey to be Conducted">
                                    <label
                                        htmlFor="rate_per_km_times"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Rate per No. of times Survey to be Conducted
                                    </label>
                                    <input
                                        id="rate_per_km_times"
                                        type="number"
                                        min={0}
                                        name="rate_per_km_times"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Rate per No. of times Survey to be Conducted"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_km_times}
                                        className={`form-input ${errors.rate_per_km_times ? "error" : inputState.rate_per_km_times ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate_per_km_times && (
                                        <span className="error-message font-size-text ">
                                            {errors.rate_per_km_times}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteRoadSurveyEquipment = ({ i, getRoadSurveyEquipment }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqroadsurveyequipmentupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getRoadSurveyEquipment();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Road Survey BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Road Survey" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Road Survey</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.description}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************

const UpdateContingenciest = ({ i, getContingencies }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        description: "",
        unit: "",
        ammount: "",
        project: ""

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "unit", "ammount"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqcontingenciesupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getContingencies();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Contingencies"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Contingencies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description
                                    </label>
                                    <input
                                        id="description"
                                        type="text"
                                        name="description"
                                        maxLength={300}
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text ">
                                            {errors.description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="unit"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Units
                                    </label>
                                    <input
                                        id="unit"
                                        type="text"
                                        name="unit"

                                        placeholder="Units"
                                        onChange={handleInputChange}
                                        value={formData.unit}
                                        className={`form-input ${errors.unit ? "error" : inputState.unit ? "success" : ""
                                            }`}
                                    />
                                    {errors.unit && (
                                        <span className="error-message font-size-text ">
                                            {errors.unit}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="ammount"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Amount
                                    </label>
                                    <input
                                        id="ammount"
                                        type="number"
                                        min={0}
                                        name="ammount"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Amount"
                                        onChange={handleInputChange}
                                        value={formData.ammount}
                                        className={`form-input ${errors.ammount ? "error" : inputState.ammount ? "success" : ""
                                            }`}
                                    />
                                    {errors.ammount && (
                                        <span className="error-message font-size-text ">
                                            {errors.ammount}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteUpdateContingenciest = ({ i, getContingencies }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/boqcontingenciesupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getContingencies();
                setShow(false);
                toast.dismiss(loadingToastId); // Dismiss loading toast
                toast.success('Contingencies BOQ data deleted successfully.')
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Contingencies" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Contingencies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete "{i.description}"</h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ****************************************************************************

const UpdateAddOfficeFurnitureHeading = ({ i, getOfficeFurnitureheading }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        BOQoffice_furnitur_equipment: "",
        project: ""

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["BOQoffice_furnitur_equipment"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqheadingtableupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeFurnitureheading();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Office Furniture Heading"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Office Furniture Heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="BOQoffice_furnitur_equipment"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Heading Description
                                    </label>
                                    <textarea
                                        id="BOQoffice_furnitur_equipment"
                                        type="text"
                                        name="BOQoffice_furnitur_equipment"
                                        // maxLength={300}
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.BOQoffice_furnitur_equipment}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.BOQoffice_furnitur_equipment
                                            ? "error"
                                            : inputState.BOQoffice_furnitur_equipment
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.BOQoffice_furnitur_equipment && (
                                        <span className="error-message font-size-text ">
                                            {errors.BOQoffice_furnitur_equipment}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


export {
    AddBreakdownOfCosts,
    AddSubprofessionalStaff,
    AddSupportStaff,
    AddTransportation,
    AddDutyTravel,
    AddOfficeRent,
    AddOfficeSupplies,
    AddOfficeFurniture,
    AddReportsPrinting,
    AddRoadSurveyEquipment,
    AddContingencies,
    UpdateBreakdownOfCosts,
    DeleteBreakdownOfCosts,
    // UpdateSubprofessionalStaff,
    DeleteSubprofessionalStaff,
    // UpdateSupportStaff,
    DeleteSupportStaff,
    UpdateTransportation,
    DeleteITransportation,
    UpdateDutyTravel,
    UpdateEmployeeBOQ,
    DeleteEmployeeBOQ,
    AddEmployeeBOQ,
    DeleteIDutyTravel,
    UpdateOfficeRent,
    DeleteOfficeRent,
    UpdateOfficeSupplies,
    DeleteOfficeSupplies,
    UpdateOfficeFurniture,
    DeleteOfficeFurniture,
    UpdateReportsPrinting,
    DeleteReportsPrinting,
    UpdateRoadSurveyEquipment,
    DeleteRoadSurveyEquipment,
    UpdateContingenciest,
    DeleteUpdateContingenciest,
    AddOfficeFurnitureHeading,
    UpdateAddOfficeFurnitureHeading
};  
